import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import TourismCategoryFilter from '../../components/ui/TourismCategoryFilter';
import OfferingsHeader from './components/OfferingsHeader';
import LocationFilter from './components/LocationFilter';
import OfferingsGrid from './components/OfferingsGrid';

const TourismOfferings = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [selectedLocation, setSelectedLocation] = useState('all');
  const [selectedPriceRange, setSelectedPriceRange] = useState('all');
  const [selectedTrail, setSelectedTrail] = useState('all');
  const [isLoading, setIsLoading] = useState(true);
  const [filteredOfferings, setFilteredOfferings] = useState([]);

  // All tourism offerings data organized by 8 trails (4 Montenegro + 4 Serbia)
  const mockOfferings = [
  // Staza 1 - "Kanjon Tare - priče o ljudima i rijeci"
  {
    id: 1,
    name: "Motel Tara MB",
    category: "accommodation",
    location: "Đurđevića Tara – most na Tari, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "Motel Tara MB je smješten pored mosta Đurđevića Tara, tako da terasa restorana kao i smještajni kapaciteti imaju pogled na most i fantastičnu prirodu. Motel ima 10 smještajnih jedinica, nacionalni 'a la carte' restoran koji raspolaže sa 70 mjesta i terasom restorana koja može da primi do 100 gostiju. U restoranu je moguće probati nacionalne specijalitete pripremljene na tradicionalan način.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763279610/1._Motel_Tara_MB_tg3j5y.jpg",
    imageAlt: "Motel Tara MB sa pogledom na most Đurđevića Tara i kanjon rijeke Tare",
    price: 45,
    priceUnit: "night",
    availability: "available",
    rating: 4.7,
    reviewCount: 89,
    features: ["Pogled na most", "Nacionalni restoran", "Terasa", "Parking"],
    certifications: ["Turistička licenca", "Kategorizovano"],
    phone: "+382 69 617 617",
    email: "info@mbturist.com",
    website: "https://www.mbturist.com",
    gps: "43.14871770243077, 19.291965160333415"
  },
  {
    id: 2,
    name: "Restoran i apartmani Most",
    category: "accommodation",
    location: "Đurđevića Tara – most na Tari, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "Ovaj objekat se nalazi pored mosta Đurđevića Tara i u ponudi imaju smještaj u apartmanima i bungalovima, restoran sa terasom sa pogledom na most u kojem se služe jela nacionalne kuhinje, kao i prostor za kampovanje. Pored ovoga se nalazi i centar za posjetioce gdje se nudi organizacija aktivnosti poput zip line, raftinga Tarom, kajaking i džip ture kroz kanjon Tare i preko Durmitorskog prstena.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763403857/2._Restoran_i_apartmani_Most_bclkao.jpg",
    imageAlt: "Restoran i apartmani Most sa terasom i pogledom na most Đurđevića Tara",
    price: 50,
    priceUnit: "night",
    availability: "available",
    rating: 4.6,
    reviewCount: 124,
    features: ["Apartmani", "Bungalovi", "Camping", "Centar za aktivnosti"],
    certifications: ["Turistička licenca", "Aktivni turizam"],
    phone: "+382 69 311 032",
    email: "office@mirotara.com",
    website: "https://www.mirotara.com",
    gps: "43.14910637960817, 19.291784475123706"
  },
  {
    id: 3,
    name: "Caffe bar Tara",
    category: "hospitality",
    location: "Đurđevića Tara – most na Tari, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "Caffe bar Tara predstavlja pravo mjesto za kratak okrijep. U svojoj ponudi alkoholna i bezalkoholna pića, a izdvajaju se domaći sokovi i rakije. Iz kafića se pruža sjajan pogled na most na Tari.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763403857/3._Caffe_bar_Tara_fsmvnj.jpg",
    imageAlt: "Caffe bar Tara sa pogledom na most i kanjon rijeke Tare",
    price: 8,
    priceUnit: "drink",
    availability: "available",
    rating: 4.4,
    reviewCount: 67,
    features: ["Domaći sokovi", "Rakije", "Pogled na most", "Terasa"],
    certifications: ["Ugostiteljska licenca"],
    phone: "+382 69 677 768",
    email: null,
    website: null,
    gps: "43.150863591535426, 19.296622452030938"
  },
  {
    id: 4,
    name: "Rafting i kamp Kljajevića Luka",
    category: "accommodation",
    location: "Đurđevića Tara – most na Tari, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "Eko kamp Kljajevića Luka nalazi se na najljepšem mjestu Đurđevića Tare. Na uređenom prostoru od 5 hektara, nalaze se sportski tereni, bungalovi za smještaj, ljetnjikovci, prostor za kampovanje, restoran. Smještaj se nudi u sobama, bungalovima, kao i kućerima (minijaturnim čobanskim kućicama za dvije osobe). U restoranu kampa se pripremaju specijaliteti nacionalne kuhinje, a od aktivnosti u ponudi su rafting, zip line, džip ture, kajaking.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763403858/4._Rafting_i_kamp_Kljajevi%C4%87a_Luka_b3mqdv.jpg",
    imageAlt: "Eko kamp Kljajevića Luka sa bungalovima i prostorom za kampovanje uz rijeku Taru",
    price: 35,
    priceUnit: "night",
    availability: "available",
    rating: 4.8,
    reviewCount: 156,
    features: ["5 hektara prostora", "Bungalovi", "Kućeri", "Sportski tereni", "Rafting"],
    certifications: ["Eko kamp", "Aktivni turizam"],
    phone: "+382 69 605 559",
    email: "kljajevicaluka-rafting@t-com.me",
    website: "https://www.tara-rafting.info",
    gps: "43.14909763824148, 19.299721754387903"
  },
  {
    id: 5,
    name: "Konoba Suza Evrope",
    category: "hospitality",
    location: "Đurđevića Tara, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "Konoba Suza Evrope se nalazi nedaleko od mosta na Tari. U svojoj ponudi imaju specijalitete nacionalne kuhinje, sa akcentom na pripremu jela sa roštilja. Bašta restorana, koja je otvorena ljeti, pruža fantastičan pogled na okolinu kanjona. Pored konobe se nalazi centar za posjetioce turističke agencije Ostojić company, gdje zainteresovani posjetioci mogu dogovoriti aktivnosti poput zip line, rafting Tarom, kanjoning i slično. Turistička agencija ima svoje kancelarije i na Žabljaku.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763403864/5._Konoba_Suza_Evrope_m9fpqm.jpg",
    imageAlt: "Konoba Suza Evrope sa baštom i pogledom na kanjon rijeke Tare",
    price: 18,
    priceUnit: "meal",
    availability: "available",
    rating: 4.7,
    reviewCount: 98,
    features: ["Jela sa roštilja", "Bašta", "Nacionalna kuhinja", "Centar za aktivnosti"],
    certifications: ["Tradicionalna kuhinja", "Turistička agencija"],
    phone: "+382 67 310 395",
    email: "ostojiccompany@t-com.me",
    website: "https://www.raftingtara.eu",
    gps: "43.16255314746395, 19.290644461152603"
  },
  {
    id: 6,
    name: "Seosko domaćinstvo Kljajevića voćnjak",
    category: "local-products",
    location: "Đurđevića Tara, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "Seosko domaćinstvo koje se bavi ruralnim turizmom od 2017. godine nalazi se nedaleko od mosta na Tari. U ponudi imaju smještaj za 15 osoba u okviru domaćinstva (porodična kuća + bungalovi), a preko puta kuće se nalazi prostor za kampovanje. Na imanju se nalazi 600 stabala šljiva, 100 stabala jabuka i 100 stabala krušaka, a porodica pravi domaće sokove, rakije i džemove od pomenutog voća. U dogovoru sa domaćicom, moguće je naručiti za doručak domaće pite ili priganice.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763403967/6._Seosko_doma%C4%87instvo_Kljajevi%C4%87a_vo%C4%87njak_vhpyjs.jpg",
    imageAlt: "Seosko domaćinstvo Kljajevića voćnjak sa voćnjacima i tradicionalnim proizvodima",
    price: 12,
    priceUnit: "item",
    availability: "available",
    rating: 4.9,
    reviewCount: 43,
    features: ["800 voćaka", "Domaći sokovi", "Rakije", "Džemovi", "Ruralni turizam"],
    certifications: ["Organska proizvodnja", "Ruralni turizam"],
    phone: "+382 67 628 512",
    email: "jelena.kljajević92@t-com.me",
    website: null,
    gps: "43.15582302552569, 19.29770095350592"
  },
  {
    id: 7,
    name: "Domaćinstvo Petrović",
    category: "local-products",
    location: "selo Kosanica, Pljevlja, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "Domaćinstvo Petrović se nalazi u selu Kosanica, na 1300 metara nadmorske visine. Porodica se bavi tradicionalno stočarstvom i obradom zemljišta, kultivacijom. Gazdinstvo posjeduje 37 h zemljišta. Na gazdinstvu se drže 23 muzne krave, 60 ovaca i 55 jagnjadi. Takođe, oni su organski proizvođači žitarica i brašna od heljde, ječma i raži.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763403967/7._Doma%C4%87instvo_Petrovi%C4%87_nyr1io.jpg",
    imageAlt: "Domaćinstvo Petrović sa stokom i organskim proizvodima na planini",
    price: 15,
    priceUnit: "item",
    availability: "available",
    rating: 4.6,
    reviewCount: 29,
    features: ["37h zemljišta", "23 muzne krave", "60 ovaca", "Organska žitarica"],
    certifications: ["Organska proizvodnja", "Tradicionalno stočarstvo"],
    phone: "+382 67 873 694",
    email: "petrovicveljko5@gmail.com",
    website: null,
    gps: "43.19585724333171, 19.319470656005624"
  },
  {
    id: 8,
    name: "Domaćinstvo Macanović",
    category: "local-products",
    location: "selo Glibaći, Pljevlja, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "Poljoprivredno gazdinstvo Macanović se nalazi u selu Glibaći, na 15 km udaljenosti od mosta na Đurđevića Tari, na putu ka Pljevljima. Željko Macanović je jedan od najvećih proizvođača organskih proizvoda u pljevaljskoj opštini. Uzgaja i prerađuje u brašno heljdu, speltu, raž, ječam, pšenicu i ovas. Ima svoj mlin, tako da se na njegovom imanju obavlja kako uzgoj tako i obrada navedenih žitarica.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763403968/8._Doma%C4%87instvo_Macanovi%C4%87_rwdzn8.jpg",
    imageAlt: "Domaćinstvo Macanović sa mlinom i organskim žitaricama",
    price: 8,
    priceUnit: "kg",
    availability: "available",
    rating: 4.8,
    reviewCount: 52,
    features: ["Vlastiti mlin", "6 vrsta žitarica", "Organska proizvodnja"],
    certifications: ["Najveći organski proizvođač", "Certificirano brašno"],
    phone: "+382 69 023 819",
    email: "zeljko.macanovic@yahoo.com",
    website: null,
    gps: "43.22754071098369, 19.25163970583612"
  },
  {
    id: 9,
    name: "Kamp Kapija Kanjona",
    category: "accommodation",
    location: "Donja Dobrilovina, Mojkovac, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "Kamp Kapija Kanjona se nalazi na samoj obali Tare, okružen netaknutom prirodom i unikatnim pejzažom. Kamp se snabdijeva solarnim panelima, a pored prostora za kampere, kamp prikolice i šatore, u ponudi su i bungalovi. U restoranu kampa se služe jela tradicionalne kuhinje, a u dogovoru sa domaćinom moguće je organizovati aktivnosti poput raftinga, kajakinga, džip safarija, ribolova i slobodnog penjanja.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763403970/9._Kamp_Kapija_Kanjona_zpbma2.png",
    imageAlt: "Kamp Kapija Kanjona na obali rijeke Tare sa bungalovima i solarnim panelima",
    price: 25,
    priceUnit: "night",
    availability: "available",
    rating: 4.5,
    reviewCount: 87,
    features: ["Solarni paneli", "Obala Tare", "Bungalovi", "Restoran"],
    certifications: ["Eko kamp", "Solarna energija"],
    phone: "+382 69 443 344",
    email: "gateofcanyon@yahoo.com",
    website: "https://www.kapijakanjona.com",
    gps: "43.051899591616376, 19.38592327846174"
  },
  {
    id: 10,
    name: "Restoran Izlet",
    category: "hospitality",
    location: "Dobrilovina, Mojkovac, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "Restoran koji se nalazi pored glavnog magistralnog puta koji vodi kroz kanjon Tare predstavlja pravo mjesto za odmor i okrijep. U ponudi restorana su jela nacionalne kuhinje od kojih se izdvajaju jela od mesa, a kao specijalitet se može izdvojiti pastrmka na žaru.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763403971/10._Restoran_Izlet_o9m14o.jpg",
    imageAlt: "Restoran Izlet pored magistralnog puta kroz kanjon Tare",
    price: 16,
    priceUnit: "meal",
    availability: "available",
    rating: 4.4,
    reviewCount: 76,
    features: ["Pastrmka na žaru", "Jela od mesa", "Magistralni put"],
    certifications: ["Nacionalna kuhinja", "Specijaliteti ribe"],
    phone: "+382 67 224 250",
    email: null,
    website: null,
    gps: "43.024269385280675, 19.397028889206698"
  },
  {
    id: 11,
    name: "Apartmani Babić",
    category: "accommodation",
    location: "Dobrilovina, Mojkovac, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "Apartmanski smještaj koji je kategorizovan sa 3 zvjezdice, nalazi se pored glavnog magistralnog puta koji vodi kroz kanjon Tare, odmah pored restorana Izvor. U ponudi su dva apartmana i sprat kuće ukupnog kapaciteta 12 ležajeva. U dogovoru sa domaćicom, moguće je pripremiti doručak poput domaćih pita i priganica, a na imanju se nalazi bašta i voćnjak sa jabukama, kruškama, trešnjama i višnjama.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763403973/11._Apartmani_Babi%C4%87_ywe6g2.jpg",
    imageAlt: "Apartmani Babić sa baštom i voćnjakom u kanjonu Tare",
    price: 40,
    priceUnit: "night",
    availability: "available",
    rating: 4.6,
    reviewCount: 61,
    features: ["3 zvjezdice", "12 ležajeva", "Voćnjak", "Domaći doručak"],
    certifications: ["Kategorizovano 3*", "Apartmanski smještaj"],
    phone: "+382 67 558 427",
    email: null,
    website: null,
    gps: "43.02516432152948, 19.395376733804817"
  },
  {
    id: 12,
    name: "Domaćinstvo Rovčanin",
    category: "local-products",
    location: "katun Zaboj, Mojkovac, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "Na 8 km udaljenosti od Dobrilovine, a oko 300 m od Zabojskog jezera, u katunu Zaboj nalazi se imanje porodice Rovčanin. Vukman je uz pomoć svih ukućana na sebi svojstven način uspješno uvezao gajenje pčela i poljoprivredu sa ugošćavanjem turista. U njihovoj ponudi su usluge degustacije proizvoda iz porodične radinosti, posluženje ukusnih jela domaće kuhinje, usluga smještaja, ali i ponuda raznih osvježavajući pića.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763403973/12._Doma%C4%87instvo_Rov%C4%8Danin_ifql2r.jpg",
    imageAlt: "Domaćinstvo Rovčanin u katunu Zaboj sa pčelama i poljoprivredom",
    price: 20,
    priceUnit: "meal",
    availability: "available",
    rating: 4.7,
    reviewCount: 38,
    features: ["Pčelarstvo", "Poljoprivreda", "Degustacija", "Zabojsko jezero"],
    certifications: ["Ruralni turizam", "Domaći proizvodi"],
    phone: "+382 67 802 873",
    email: null,
    website: null,
    gps: "43.01305184476906, 19.37082080322521"
  },
  {
    id: 13,
    name: "Eko oaza Suza Evrope",
    category: "accommodation",
    location: "Dobrilovina, Mojkovac, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "Seosko domaćinstvo koje se bavi ruralnim turizmom zadnjih 15 godina napravilo je svoju oazu na 5 minuta šetnje od obale Tare. Okruženo zelenilom i nevjerovatnom prirodom kanjona, na ovom prostoru se nudi prostor za kampovanje, smještaj u bungalovima, a restoran samo za goste kampa priprema tradicionalnu hranu.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763403975/13._Eko_oaza_Suza_Evrope_elnwp3.jpg",
    imageAlt: "Eko oaza Suza Evrope sa bungalovima i kampom uz rijeku Taru",
    price: 28,
    priceUnit: "night",
    availability: "available",
    rating: 4.5,
    reviewCount: 94,
    features: ["15 godina iskustva", "Bungalovi", "Kampovanje", "5min do Tare"],
    certifications: ["Ruralni turizam", "Eko oaza"],
    phone: "+382 69 103 113",
    email: "ekooazatara@gmail.com",
    website: null,
    gps: "43.01757853756858, 19.41015122586673"
  },
  {
    id: 14,
    name: "Vila Montana",
    category: "accommodation",
    location: "Dobrilovina, Mojkovac, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "Vila Montana se nalazi u Dobrilovini, nedaleko od restorana Izvor i manastira Dobrilovina. Kuća je u potpunosti opremljena i prilagođena potrebama gostiju. Oko kuće se nalazi prostrano dvorište sa pogledom na prirodu kanjona.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763403976/14._Vila_Montana_otlj3j.jpg",
    imageAlt: "Vila Montana sa dvorištem i pogledom na kanjon u Dobrilovini",
    price: 55,
    priceUnit: "night",
    availability: "available",
    rating: 4.3,
    reviewCount: 27,
    features: ["Opremljena kuća", "Prostrano dvorište", "Blizu manastira"],
    certifications: ["Vila smještaj", "Kanjon Tare"],
    phone: "+382 69 448 810",
    email: "bojanfilipovic10@gmail.com",
    website: null,
    gps: "43.02514752161579, 19.39906463645629"
  },
  {
    id: 15,
    name: "Kamp Kaludra",
    category: "accommodation",
    location: "Dobrilovina, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "Kamp Kaludra nudi gostima ugodan smještaj u vikendici i bungalovu na imanju, a postoji slobodan prostor i za postavljanje šatora. Gostima je na raspolaganju i pribor za roštilj. Doručak se služi svakog jutra u okviru vikendice. Okolina kampa je pogodna za pješačenje i vožnju bicikla.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763403976/15._Kamp_Kaludra_mlzlsf.jpg",
    imageAlt: "Kamp Kaludra sa vikendcom, bungalovima i prostorom za šatore",
    price: 18,
    priceUnit: "night",
    availability: "available",
    rating: 4.2,
    reviewCount: 53,
    features: ["Vikendica", "Bungalov", "Šatori", "Pribor za roštilj"],
    certifications: ["Kamp smještaj", "Biciklizam"],
    phone: "+382 67 623 855",
    email: null,
    website: null,
    gps: "42.9979220737247, 19.45470585170929"
  },
  {
    id: 16,
    name: "Manastir Dobrilovina",
    category: "local-products",
    location: "Dobrilovina, Mojkovac, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "U razgovoru sa mati Makrinom, koja živi u okviru manastira Dobrilovina u kanjonu Tare, došli smo do informacija da pored kulturno istorijske atrakcije kakav je manastir, posjetioci mogu vidjeti da se ovdje stanovnici bave poljoprivredom, ali i pčelarstvom. Posjeduju desetak košnica koje daju oko 50 kg meda godišnje.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763403978/16._Manastir_Dobrilovina_wjsoaw.jpg",
    imageAlt: "Manastir Dobrilovina sa pčelinjacima i poljoprivrednim aktivnostima",
    price: 10,
    priceUnit: "item",
    availability: "available",
    rating: 4.8,
    reviewCount: 15,
    features: ["Manastir", "Pčelarstvo", "50kg meda godišnje", "Kulturna baština"],
    certifications: ["Vjerski objekat", "Tradicionalno pčelarstvo"],
    phone: "+382 68 023 303",
    email: null,
    website: null,
    gps: "43.02783205053749, 19.400825088131537"
  },
  {
    id: 17,
    name: "Domaćinstvo Medojević",
    category: "local-products",
    location: "Kaludra, Mojkovac, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "Poljoprivreda je porodična tradicija koju je zajedno sa pčelarstvom Đoko naslijedio od oca. Obilazeći imanje u društvu sa domaćinom posjetioci će doživjeti njihovu svakodnevicu i stvoriti sliku o uloženom radu u pčelinjaku, bašti, livadama i njivama. U bašti sa oko 470 stabala voćaka, zato su u bogatoj lepezi domaćih proizvoda rakija šljiva, jabuka i kruška, koje domaćin peče na tradicionalan način koristeći kazan poznat kao čučavac.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763403979/17._Doma%C4%87instvo_Medojevi%C4%87_h8qam5.jpg",
    imageAlt: "Domaćinstvo Medojević sa pčelinjacima, voćnjacima i tradicionalnim proizvodima",
    price: 14,
    priceUnit: "item",
    availability: "available",
    rating: 4.9,
    reviewCount: 31,
    features: ["470 voćaka", "Pčelarstvo", "Tradiconalne rakije", "Čučavac"],
    certifications: ["Porodična tradicija", "Tradicionalno pečenje"],
    phone: "+382 67 507 085",
    email: "medojevic.ivana@gmail.com",
    website: null,
    gps: "43.000696854086414, 19.45709871916862"
  },
  {
    id: 18,
    name: "Domaćinstvo Madžgalj",
    category: "local-products",
    location: "selo Podbišće, Mojkovac, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "Domaćinstvo Madžgalja se bavi pčelarstvom zadnjih dvadeset godina. U svom posjedu imaju oko 100 košnica koje godišnje daju oko 900 kg meda, kao i propolis, vosak, medovaču i medovinu. Sve navedene proizvode, porodica promoviše na sajmovima, ali i imaju mrežu stalnih kupaca, te proizvode plasiraju i u prodavnicama zdrave hrane širom Crne Gore.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763403980/19._Doma%C4%87instvo_Mad%C5%BEgalj_dylhay.jpg",
    imageAlt: "Domaćinstvo Madžgalj sa 100 košnica i proizvodima od meda",
    price: 16,
    priceUnit: "item",
    availability: "available",
    rating: 4.8,
    reviewCount: 42,
    features: ["100 košnica", "900kg meda", "Propolis", "Medovina"],
    certifications: ["20 godina iskustva", "Sajmovi"],
    phone: "+382 69 681 796",
    email: null,
    website: null,
    gps: "42.94608611111111, 19.574419444444445"
  },
  {
    id: 19,
    name: "Domaćinstvo Popović",
    category: "local-products",
    location: "Katun Okrugljak, Mojkovac, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "U katunu Okrugljak, koji važi za najbogatiji katun u Crnoj Gori kada je stočni fond u pitanju, domaćinstvo Popovića boravi od početka juna pa do kraja oktobra. Osim što posjetioci imaju priliku da vide kako se vodi računa o 200 ovaca i goveda, domaćica Danka će vam pokazati kako se muze krava, pravi sir, i kako se, usled nedostatka električne energije, na tradicionalan način održavaju meso i drugi proizvodi.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763403982/20._Doma%C4%87instvo_Popovi%C4%87_szk8g8.jpg",
    imageAlt: "Domaćinstvo Popović u najbogatnijem katunu sa 200 ovaca i govedima",
    price: 25,
    priceUnit: "meal",
    availability: "available",
    rating: 4.6,
    reviewCount: 28,
    features: ["Najbogatiji katun", "200 ovaca", "Tradicionalno čuvanje", "Juno-oktobar"],
    certifications: ["Katunski život", "Tradicionalno stočarstvo"],
    phone: "+382 69 255 464",
    email: null,
    website: null,
    gps: "42.95752742733942, 19.40299054061129"
  },
  {
    id: 20,
    name: "Domaćinstvo Vuletić",
    category: "local-products",
    location: "katun Okrugljak, Mojkovac, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "Porodica Vuletić boravi u katunu od početka juna do početka oktobra, kada brinu o preko 300 ovaca, konja i goveda. Od domaćina Vladana, posjetioci mogu čuti zanimljivosti o katunu, te kako se nekada živjelo, a kako danas nekoliko preostalih porodica u ovom dijelu Sinjajevine drži do tradicionalnog izdiga. Ovaj ljubazni domaćin je dobio mnogo nagrada za mliječne proizvode i jagnjetinu.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763403983/21._Doma%C4%87instvo_Vuleti%C4%87_exd39z.jpg	",
    imageAlt: "Domaćinstvo Vuletić sa preko 300 ovaca, konja i goveda u katunu",
    price: 30,
    priceUnit: "meal",
    availability: "available",
    rating: 4.9,
    reviewCount: 19,
    features: ["300+ stoke", "Nagrade za proizvode", "Jahanje konja", "Tradicionalni izdiga"],
    certifications: ["Nagrađivani proizvodi", "Sinjajevina"],
    phone: "+382 67 317 707",
    email: null,
    website: null,
    gps: "42.957181938559394, 19.403709372651207"
  },
  {
    id: 21,
    name: "Domaćinstvo Moračanin",
    category: "local-products",
    location: "katun Borova glava, Mojkovac, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "Domaćinstvo porodice Moračanin, koja boravi u katunu Borova Glava od kraja maja do kraja septembra, za razliku od drugih porodica na ovom i obližnjim katunima, ne izdižu radi stoke. Štaviše, oni imaju samo jednu kravu, a na Sinjajevini borave najviše zbog odmora, čistog vazduha i klime, koja može biti lijek za neke zdravstvene tegobe.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763403986/23._Doma%C4%87instvo_Mili%C4%8Di%C4%87_puqf1l.jpg ",
    imageAlt: "Domaćinstvo Moračanin u katunu Borova glava fokusirano na odmor i zdravlje",
    price: 18,
    priceUnit: "meal",
    availability: "available",
    rating: 4.4,
    reviewCount: 22,
    features: ["Zdravstveni odmor", "Čist vazduh", "Klima lijek", "Maja-septembar"],
    certifications: ["Zdravstveni turizam", "Čist vazduh"],
    phone: "+382 69 943 185",
    email: null,
    website: null,
    gps: "42.93916930475138, 19.434155740046315"
  },
  {
    id: 22,
    name: "Domaćinstvo Miličić",
    category: "local-products",
    location: "katun Borova glava, Mojkovac, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "Domaćinstvo Obrada Miličića boravi u katunu Borova Glava od kraja maja do kraja oktobra. Porodica vodi brigu o 22 krave i 180 ovaca, te od njih možete čuti koliko je zahtjevno držati veliki broj stoke, ali i prisustvovati muža krava i ovaca, pravljenju sira i drugim aktivnostima u ovom seoskom domaćinstvu. Miličići sve one koji se zadese na ovom katunu poslužuju sokom od zove i kopriva, pitom od štavlja, kopriva, mesa, sira.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763403986/23._Doma%C4%87instvo_Mili%C4%8Di%C4%87_puqf1l.jpg",
    imageAlt: "Domaćinstvo Miličić sa 22 krave i 180 ovaca u katunu Borova glava",
    price: 22,
    priceUnit: "meal",
    availability: "available",
    rating: 4.7,
    reviewCount: 34,
    features: ["202 stoke", "Muža i pravljenje sira", "Sok od zove", "Maja-oktobar"],
    certifications: ["Veliki stočni fond", "Tradicionalne pite"],
    phone: "+382 69 474 592",
    email: null,
    website: null,
    gps: "42.93973768223596, 19.433478495343074"
  },
  {
    id: 23,
    name: "Domaćinstvo Vujisić",
    category: "local-products",
    location: "katun Borova glava, Mojkovac, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "Na obroncima Sinjajevine, u katunu Borova Glava, porodica Vujisić izdiže već godinama u periodu od maja do polovine oktobra. U ovom skromnom seoskom domaćinstvu, posjetioci mogu da se goste domaćim proizvodima poput sira, goveđe i svinjske pršute, mlijeka i povrća iz njihove bašte. Kraj je bogat borovnicama, tako da domaćica pravi domaći sok, a peku i rakiju od šljiva i jabuka.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763403987/24._Doma%C4%87instvo_Vujisi%C4%87_rneswi.jpg",
    imageAlt: "Domaćinstvo Vujisić u katunu sa tradicionalnim proizvodima i borovnicama",
    price: 16,
    priceUnit: "item",
    availability: "available",
    rating: 4.5,
    reviewCount: 26,
    features: ["Pršute", "Borovnice", "Domaći sok", "Bez struje i signala"],
    certifications: ["Tradicionalni život", "Autentičnost"],
    phone: "+382 69 464 938",
    email: null,
    website: null,
    gps: "42.93886774045944, 19.434950694247906"
  },
  {
    id: 24,
    name: "Planinarski dom Ckara",
    category: "accommodation",
    location: "katun Ckara, Sinjajevina, Mojkovac, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "Planinarski dom Ckara se nalazi na 1624 metara nadmorske visine u istoimenom katunu na Sinjajevini. Otvoren je za sve posjetioce u periodu od maja do oktobra. Izgrađen je u skladu sa ambijentom koji ga okružuje, a smještajni kapacitet broji 40 ležajeva. U okolini planinarskog doma se nalaze atraktivni lokaliteti kao što su paraglajding poletište (mjesto Pogledala), pećine, stijene za alpinizam i drugi.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763403990/25._Planinarski_dom_Ckara_nwvvew.jpg",
    imageAlt: "Planinarski dom Ckara na 1624m visine sa pogledom na Sinjajevinu",
    price: 15,
    priceUnit: "night",
    availability: "available",
    rating: 4.6,
    reviewCount: 78,
    features: ["1624m n.v.", "40 ležajeva", "Paraglajding", "Alpinizam"],
    certifications: ["Planinarski dom", "Sinjajevina"],
    phone: "+382 67 888 866",
    email: null,
    website: null,
    gps: "42.94786396221926, 19.502567402191147"
  },
  {
    id: 25,
    name: "Domaćinstvo Španjević",
    category: "local-products",
    location: "katun Planinica, Sinjajevina, Mojkovac, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "U katunu Planinica, na Sinjajevini, u periodu od maja do oktobra živi porodica Španjević. Ljubazni domaćin Stevan, koji radi kao rendžer Nacionalnog parka Durmitor, rado će pomoći svim putnicima i pružiti potrebne informacije o Nacionalnom parku, planini Sinjajevini i drugim prirodnim atrakcijama koje se nalaze u blizini. Porodica je u mogućnosti da pruži smještaj i pripremi hranu za nekoliko osoba.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763403990/26._Doma%C4%87instvo_%C5%A0panjevi%C4%87_kz0vuh.jpg",
    imageAlt: "Domaćinstvo Španjević u katunu Planinica sa rendžerom NP Durmitor",
    price: 20,
    priceUnit: "meal",
    availability: "available",
    rating: 4.8,
    reviewCount: 25,
    features: ["Rendžer NP Durmitor", "Informacije o parku", "Rijedak izvor vode", "Maja-oktobar"],
    certifications: ["NP Durmitor", "Stručni vodič"],
    phone: "+382 69 554 962",
    email: null,
    website: null,
    gps: "43.14447772918354, 19.02000686090336"
  },
  {
    id: 26,
    name: "Hotel Ravnjak",
    category: "accommodation",
    location: "Bistrica bb, Mojkovac, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "Smješten u atraktivnom prirodnom ambijentu, hotel Ravnjak se nalazi na 15 kilometara od Mojkovca u kanjonu Tare. Pored smještaja, hotel ima otvoreni i zatvoreni restoranski prostor, a od specijaliteta se izdvajaju Mojkovački stek, kačamak, cicvara i heljdija. Što se tiče aktivnosti, u hotelu mogu pomoći u organizaciji pješačkih tura, džip safarija, raftinga, kanjoninga, paraglajdinga, jahanja konja i drugih.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763403991/27._Hotel_Ravnjak_dfggjo.jpg",
    imageAlt: "Hotel Ravnjak u prirodnom ambijentu kanjona Tare sa restoranom",
    price: 65,
    priceUnit: "night",
    availability: "available",
    rating: 4.4,
    reviewCount: 83,
    features: ["Mojkovački stek", "Otvoreni/zatvoreni restoran", "Aktivni turizam"],
    certifications: ["Hotel kategorija", "Kanjon Tare"],
    phone: "+382 67 557 466",
    email: "info@ravnjak-hotel.com",
    website: "https://www.ravnjak-hotel.com",
    gps: "42.98967422718784, 19.41159124033144"
  },
  {
    id: 27,
    name: "Kamp Šćepanović",
    category: "accommodation",
    location: "Donja Polja, Mojkovac, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "Kamp Šćepanović se nalazi u Donjim Poljima, nedaleko od Mojkovca. Pored kamp prostora, na imanju se nudi smještaj u 9 bungalova i dva apartmana. Posebna pogodnost je ta što postoji posebna kuhinja za kampere koja je slobodna za korišćenje. Na imanju se nalaze i vanjski toalet i tuš. U dogovoru sa domaćinima, moguće je organizovati prevoz po potrebi.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763403993/28._Kamp_%C5%A0%C4%87epanovi%C4%87_grm9ar.jpg",
    imageAlt: "Kamp Šćepanović sa 9 bungalova, apartmanima i kuhinjom za kampere",
    price: 20,
    priceUnit: "night",
    availability: "available",
    rating: 4.3,
    reviewCount: 55,
    features: ["9 bungalova", "Kuhinja za kampere", "2 apartmana", "Prevoz"],
    certifications: ["Kamp smještaj", "Donja Polja"],
    phone: "+382 68 041 891",
    email: "kampovanje@gmail.com",
    website: null,
    gps: "42.97185006761835, 19.53210586816673"
  },
  {
    id: 28,
    name: "Kamp Rabrenović",
    category: "accommodation",
    location: "Donja Polja, Mojkovac, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "Poslujući od 2018. godine, porodica Rabrenović na svom imanju nudi smještaj ukupnog kapaciteta 40 ležajeva raspoređenih u 6 bungalova, 3 sobe u kući, 3 kućice na drvetu i 2 kućice u zemlji 'hobit house'. Pored pomenutih kapaciteta, na imanju postoje svi uslovi za kamp kućice i šatore i dovoljno prostora da se smjesti 20 vozila. U restoranu se služe jela nacionalne kuhinje.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763403993/29._Kamp_Rabrenovi%C4%87_oq2wve.jpg",
    imageAlt: "Kamp Rabrenović sa hobbit kućama, kućicama na drvetu i sauna",
    price: 30,
    priceUnit: "night",
    availability: "available",
    rating: 4.7,
    reviewCount: 91,
    features: ["Hobit kuće", "Kućice na drvetu", "Sauna i jakuzzi", "40 ležajeva"],
    certifications: ["Od 2018.", "Jedinstveni smještaj"],
    phone: "+382 67 888 866",
    email: "camprabrenovic@gmail.com",
    website: null,
    gps: "42.97073179285212, 19.534637198226086"
  },
  {
    id: 29,
    name: "Hotel Serdar",
    category: "accommodation",
    location: "Polja, Mojkovac, Montenegro",
    trail: "kanjon-tare",
    trailName: "Kanjon Tare - priče o ljudima i rijeci",
    description: "Moderan hotel Serdar se nalazi nedaleko od Mojkovca, na putu ka kanjonu Tare. Pored udobnog smještaja, u sklopu hotela se nalazi restoran nacionalne kuhinje, a od specijaliteta se izdvaja domaća teletina ispod sača, a od proizvoda domaće rakije i vina. Ljubazno osoblje hotela može pomoći zainteresovanim gostima u organizaciji aktivnosti poput raftinga, džip safarija i ture kvadovima kao i pješačke ture.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763403994/30._Hotel_Serdar_radfrg.jpg",
    imageAlt: "Hotel Serdar sa restoranom nacionalne kuhinje i telećim specijalitetima",
    price: 58,
    priceUnit: "night",
    availability: "available",
    rating: 4.5,
    reviewCount: 69,
    features: ["Teletina ispod sača", "Domaće rakije", "Kvadovi", "Moderan hotel"],
    certifications: ["Hotel kategorija", "Nacionalna kuhinja"],
    phone: "+382 69 051 245",
    email: "doopeja@t-com.me",
    website: null,
    gps: "42.963884134299036, 19.550065020357223"
  },

  // Staza 2 - "Legende i priče iz srednjovjekovnog Brskova"
  {
    id: 30,
    name: "Restoran i hotel Most",
    category: "accommodation",
    location: "Babića polja, Mojkovac, Montenegro",
    trail: "srednjovjekovni-brskov",
    trailName: "Legende i priče iz srednjovjekovnog Brskova",
    description: "Restoran i hotel Most koji se nalazi nedaleko od ulaza u Mojkovac i u blizini starog mosta na Tari i info centra, uspješno posluje više od 15 godina. Kapacitet smještaja je sedam soba, a u restoranu hotela se služe jela nacionalne kuhinje. Od specijaliteta se izdvajaju pite, kačamak, cicvara, kuvana i dimnjena jagnjetina.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763404787/1._Restoran_i_hotel_Most_i6362r.jpg ",
    imageAlt: "Restoran i hotel Most blizu starog mosta na Tari sa info centrom",
    price: 48,
    priceUnit: "night",
    availability: "available",
    rating: 4.6,
    reviewCount: 115,
    features: ["15 godina iskustva", "7 soba", "Dimnjena jagnjetina", "Blizu info centra"],
    certifications: ["15+ godina rada", "Nacionalna kuhinja"],
    phone: "+382 67 224 282",
    email: "danilovuc@t-com.me",
    website: null,
    gps: "42.95773056434104, 19.5747281566199"
  },
  {
    id: 31,
    name: "Tara Riverside",
    category: "accommodation",
    location: "Junaka mojkovačke bitke 21, Mojkovac, Montenegro",
    trail: "srednjovjekovni-brskov",
    trailName: "Legende i priče iz srednjovjekovnog Brskova",
    description: "Tara Riverside se nalazi u Mojkovcu, na obali Tare, sa pogledom na Stari most i rijeku. Raspolažu sa 4 bungalova koji imaju terasu i sopstveno kupatilo, ukupnog kapaciteta 12 mjesta. U dogovoru sa domaćinima, moguće je dogovoriti pripremu doručka. Na trpezi za goste se redovno nalaze cijeđeni sokovi od voća koje domaćini sami uzgajaju – jabuka, šljiva, zova, kruška i šargarepa, kao i domaća rakija.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763404788/2._Tara_Riverside_pqikgd.jpg",
    imageAlt: "Tara Riverside na obali rijeke Tare sa bungalovima i pogledom na Stari most",
    price: 42,
    priceUnit: "night",
    availability: "available",
    rating: 4.8,
    reviewCount: 67,
    features: ["4 bungalova", "Pogled na most", "Domaći sokovi", "Čaj od origana"],
    certifications: ["Bungalovi sa terasom", "Domaći proizvodi"],
    phone: "+382 67 940 542",
    email: "tarariverside.mojkovac@gmail.com",
    website: null,
    gps: "42.95633686753435, 19.5774925276031"
  },
  {
    id: 32,
    name: "Hotel Dulović",
    category: "accommodation",
    location: "Trg Ljubomira Bakoča, Mojkovac, Montenegro",
    trail: "srednjovjekovni-brskov",
    trailName: "Legende i priče iz srednjovjekovnog Brskova",
    description: "Hotel Dulović se nalazi u centru Mojkovca, grada koji se nalazi između dva planinska masiva- Sinjajevine i Bjelasice, a uz to se u blizini nalazi i Nacionalni park Biogradska gora. Udoban i moderan smještaj karakteriše ovaj hotel, koji je pogodan za sve turiste koji žele da uživaju u netaknutoj prirodi kojom je okružen Mojkovac. Hotelska ponuda se sastoji od sedam soba ukupnog kapaciteta 18 ležajeva.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763404788/3._Hotel_Dulovi%C4%87_qppoax.jpg",
    imageAlt: "Hotel Dulović u centru Mojkovca između Sinjajevine i Bjelasice",
    price: 52,
    priceUnit: "night",
    availability: "available",
    rating: 4.4,
    reviewCount: 88,
    features: ["Centar Mojkovca", "18 ležajeva", "Biogradska gora", "Moderna soba"],
    certifications: ["Hotel kategorija", "Centralna lokacija"],
    phone: "+382 50 472 615",
    email: null,
    website: null,
    gps: "42.96146396053915, 19.578946481490984"
  },
  {
    id: 33,
    name: "Motel Krstac",
    category: "accommodation",
    location: "Stevanovac, Mojkovac, Montenegro",
    trail: "srednjovjekovni-brskov",
    trailName: "Legende i priče iz srednjovjekovnog Brskova",
    description: "Na pet kilometara od Mojkovca, na glavnoj magistrali Podgorica-Beograd, nalazi se motel Krstac. Nedaleko od motela se nalazi i rijeka Tara, čineći ovaj motel savršeno mjesto i za ljubitelje raftinga. Smještajni kapaciteti čine komforne i moderno uređene sobe po najvišim standardima i sa zasebnim kupatilima, a u ponudi su i opremljeni i funkcionalni bungalovi.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763404789/4._Motel_Krstac_enbom2.jpg",
    imageAlt: "Motel Krstac na magistrali Podgorica-Beograd blizu rijeke Tare",
    price: 44,
    priceUnit: "night",
    availability: "available",
    rating: 4.5,
    reviewCount: 72,
    features: ["Magistrala PG-BG", "Bungalovi", "Blizu Tare", "Moderno uređeno"],
    certifications: ["Motel standardí", "Rafting pristup"],
    phone: "+382 69 264 254",
    email: "motelkrstac@hotmail.com",
    website: null,
    gps: "42.98405916386036, 19.55334821170244"
  },
  {
    id: 34,
    name: "Motel Tara",
    category: "accommodation",
    location: "Kraljevo kolo, Mojkovac, Montenegro",
    trail: "srednjovjekovni-brskov",
    trailName: "Legende i priče iz srednjovjekovnog Brskova",
    description: "Motel Tara, koji je otvoren 2008. godine, nalazi se na izuzetno atraktivnoj lokaciji, na pet kilometara od Mojkovca sa jedne strane, i tri kilometra od Biogradskog jezera sa druge. Smješten na samoj obali Tare, najljepše i najčistije rijeke Evrope, ovaj motel sa ukupno osam soba čini prijatno i intimno mjesto za odmor u srcu sjevera Crne Gore.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763404791/5._Motel_Tara_itnvvz.jpg",
    imageAlt: "Motel Tara na obali najčistije rijeke Evrope sa 8 soba",
    price: 46,
    priceUnit: "night",
    availability: "available",
    rating: 4.6,
    reviewCount: 95,
    features: ["Obala Tare", "8 soba", "Biogradsko jezero", "Najčistija rijeka"],
    certifications: ["Od 2008.", "Intimno mjesto"],
    phone: "+382 69 447 012",
    email: null,
    website: null,
    gps: "42.92219976876882, 19.57749308675674"
  },
  {
    id: 35,
    name: "Etno selo Žurić",
    category: "accommodation",
    location: "Bjelojevićki put 7, Bjelovići, Mojkovac, Montenegro",
    trail: "srednjovjekovni-brskov",
    trailName: "Legende i priče iz srednjovjekovnog Brskova",
    description: "Smješteno u zaseoku na padinama Bjelasice, etno selo Žurić pruža fantastičan pogled na dolinu Mojkovca. U ponudi je smještajni kapacitet od ukupno 14 ležajeva raspoređenih u dva bungalova i dva apartmana. Na imanju se nalazi ribnjak, voćnjaci i njiva, tako da su gosti sigurni da svi specijaliteti koji se pripremaju su domaćeg porijekla.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763404791/6._Etno_selo_%C5%BDuri%C4%87_mfxshq.jpg",
    imageAlt: "Etno selo Žurić na padinama Bjelasice sa pogledom na dolinu Mojkovca",
    price: 38,
    priceUnit: "night",
    availability: "available",
    rating: 4.7,
    reviewCount: 51,
    features: ["Padine Bjelasice", "14 ležajeva", "Ribnjak", "Domaći specijaliteti"],
    certifications: ["Etno selo", "Domaće porijeklo"],
    phone: "+382 69 325 345",
    email: "etnoselozuric@gmail.com",
    website: null,
    gps: "42.93552602163489, 19.59510095452047"
  },
  {
    id: 36,
    name: "Imanje Medojević",
    category: "local-products",
    location: "Bojna Njiva, Mojkovac, Montenegro",
    trail: "srednjovjekovni-brskov",
    trailName: "Legende i priče iz srednjovjekovnog Brskova",
    description: "Adaptacija seoske porodične kuće je donijela jedinstven smještaj i iskustvo za sve goste koji obiđu imanje porodice Medojević. Pored smještaja ukupnog kapaciteta 6 ležajeva, na imanju se nalazi ljetnjikovac, ribnjak, voćnjak i bašta, a za najmlađe je napravljena i kućica na drvetu. Domaćin Miroslav Medojević je registrovan kao organski proizvođač soka od aronije.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763404792/7._Imanje_Medojevi%C4%87_x0gxte.jpg",
    imageAlt: "Imanje Medojević sa kućicom na drvetu i organskim proizvodima od aronije",
    price: 16,
    priceUnit: "item",
    availability: "available",
    rating: 4.8,
    reviewCount: 33,
    features: ["Kućica na drvetu", "Organski sok aronije", "Ribnjak", "6 ležajeva"],
    certifications: ["Organski proizvođač", "Registrovan"],
    phone: "+382 69 102 619",
    email: "miroslavmedojevic@yahoo.com",
    website: null,
    gps: "42.96500745709161, 19.59068703729998"
  },
  {
    id: 37,
    name: "Seosko domaćinstvo Vukadinović",
    category: "local-products",
    location: "Bojna Njiva, Mojkovac, Montenegro",
    trail: "srednjovjekovni-brskov",
    trailName: "Legende i priče iz srednjovjekovnog Brskova",
    description: "Kategorizovano kao seosko domaćinstvo sa tri zvjezdice od 2013. godine, domaćinstvo ima smještajni kapacitet od ukupno 7 ležaja (5 u apartmanu i 2 u bungalovu). Na raspolaganju su ljetnja kuhinja, a gosti redovno učestvuju u aktivnostima na imanju. Na imanju se nalaze prostrani voćnjaci šljiva, oraha, višnji, trešanja i jabuka, a domaćini su sertifikovani organski proizvođači sokova.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763404793/8._Seosko_doma%C4%87instvo_Vukadinovi%C4%87_w5zmu4.jpg",
    imageAlt: "Seosko domaćinstvo Vukadinović sa organskim voćnjacima i sertifikovanim sokovima",
    price: 14,
    priceUnit: "item",
    availability: "available",
    rating: 4.9,
    reviewCount: 41,
    features: ["3 zvjezdice", "Sertifikovani sokovi", "Prostrani voćnjaci", "Od 2013."],
    certifications: ["Kategorizovano 3*", "Organski proizvođač"],
    phone: "+382 67 438 678",
    email: null,
    website: null,
    gps: "42.96954378463994, 19.596206055688906"
  },
  {
    id: 38,
    name: "Planinarski dom Džambas",
    category: "accommodation",
    location: "katun Mučnica, Bjelasica, Mojkovac, Montenegro",
    trail: "srednjovjekovni-brskov",
    trailName: "Legende i priče iz srednjovjekovnog Brskova",
    description: "Planinarski dom Džambas se nalazi na planini Bjelasici, ispod vrha Mučnica. Smještajni kapacitet čini ukupno 50 ležajeva, a za druženje je pogodan prostrani dnevni boravak na prizemlju doma. Dom je otvoren za sve planinare, rekreativce i ljubitelje prirode. Za hranu je zadužena domaćica koja priprema tradicionalna jela poput kačamaka, cicvare, raznih vrsta pita.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763404795/9._Planinarski_dom_D%C5%BEambas_dvud7r.jpg",
    imageAlt: "Planinarski dom Džambas na Bjelasici ispod vrha Mučnica sa 50 ležajeva",
    price: 18,
    priceUnit: "night",
    availability: "available",
    rating: 4.5,
    reviewCount: 67,
    features: ["50 ležajeva", "Vrh Mučnica", "Tradicionalna jela", "Dnevni boravak"],
    certifications: ["Planinarski dom", "Bjelasica"],
    phone: "+382 67 554 351",
    email: null,
    website: null,
    gps: "42.94238711846082, 19.641637318389446"
  },

  // Staza 3 - "Od glečera do Grebaje"
  {
    id: 39,
    name: "Eko naselje Deljanin",
    category: "accommodation",
    location: "Dolina Grebaje, Gusinje, Montenegro",
    trail: "od-glecera-do-grebaje",
    trailName: "Od glečera do Grebaje",
    description: "Eko naselje Deljanin se nalazi na samom ulazu u dolinu Grebaje u Nacionalnom parku Prokletije. Kompleks čine jedna vikendica i sedam bungalova, ukupnog smještajnog kapaciteta 35 ležajeva. Pored smještaja, na imanju se nalazi zajednička kuhinja u kojoj je moguće pripremati samostalno hranu, a pored nje je i ognjište za pripremanje roštilja koje je pogodno i za večernje druženje uz logorsku vatru.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405013/1._Eko_naselje_Deljanin_kjkiye.jpg",
    imageAlt: "Eko naselje Deljanin u dolini Grebaje sa bungalovima i planinarskim ambijentom",
    price: 32,
    priceUnit: "night",
    availability: "available",
    rating: 4.7,
    reviewCount: 89,
    features: ["35 ležajeva", "7 bungalova", "Zajednička kuhinja", "Vodič za ture"],
    certifications: ["Eko naselje", "Prokletije NP"],
    phone: "+382 68 589 935",
    email: "deljaninalen87@gmail.com",
    website: "https://www.deljaninecovillage.me",
    gps: "42.52392305492494, 19.787847903848554"
  },
  {
    id: 40,
    name: "Eko katun Pavićević",
    category: "accommodation",
    location: "Dolina Grebaje, Gusinje, Montenegro",
    trail: "od-glecera-do-grebaje",
    trailName: "Od glečera do Grebaje",
    description: "Eko katun Pavićević u svojoj ponudi ima komforan planinski smještaj u četiri velika bungalova, kao i restoran koji služi jela nacionalne kuhinje. Ispred restorana se nalazi i mini igralište za djecu, a početak brojnih planinarskih staza se nalaze nedaleko odavde. U dogovoru sa domaćinima, moguće je organizovati pješačke ture i obilazak okoline.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405014/2._Eko_katun_Pavi%C4%87evi%C4%87_xp6ggo.jpg",
    imageAlt: "Eko katun Pavićević sa 4 bungalova i restoranom u dolini Grebaje",
    price: 36,
    priceUnit: "night",
    availability: "available",
    rating: 4.6,
    reviewCount: 73,
    features: ["4 velika bungalova", "Restoran", "Mini igralište", "Planinarske staze"],
    certifications: ["Eko katun", "Nacionalna kuhinja"],
    phone: "+382 67 123 005",
    email: "ekokatungrebaje@live.com",
    website: null,
    gps: "42.52288332971426, 19.78705394383854"
  },
  {
    id: 41,
    name: "Bungalovi Tuzović",
    category: "accommodation",
    location: "Dolina Grebaje, Gusinje, Montenegro",
    trail: "od-glecera-do-grebaje",
    trailName: "Od glečera do Grebaje",
    description: "Porodica Tuzović nudi smještaj na svom imanju u obliku šest bungalova, ukupnog kapaciteta 15 ležajeva. Svi bungalovi su opremljeni mini kuhinjama i kupatilima. Pored smještaja, u dogovoru sa domaćicom, gosti mogu naručiti tradicionalni doručak koji se sastoji od domaćeg hljeba, priganica, pita, kao i raznih džemova, meda i domaćeg sira.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405014/2._Eko_katun_Pavi%C4%87evi%C4%87_xp6ggo.jpg",
    imageAlt: "Bungalovi Tuzović sa mini kuhinjama i tradicionalnim doručkom",
    price: 28,
    priceUnit: "night",
    availability: "available",
    rating: 4.4,
    reviewCount: 56,
    features: ["6 bungalova", "15 ležajeva", "Mini kuhinje", "Tradicionalni doručak"],
    certifications: ["Porodični smještaj", "Domaći proizvodi"],
    phone: "+382 68 808 788",
    email: null,
    website: null,
    gps: "42.52233369040602, 19.78702234254071"
  },
  {
    id: 42,
    name: "Sobe Vučetić",
    category: "accommodation",
    location: "Dolina Grebaje, Gusinje, Montenegro",
    trail: "od-glecera-do-grebaje",
    trailName: "Od glečera do Grebaje",
    description: "Planinska kuća porodice Vučetić predstavlja idealno mjesto za odmor i polazište za obilazak prirode Prokletija. Ova kuća ima ukupan kapacitet 12 kreveta, raspoređenih u 3 spavaće sobe, a tu su i dva kupatila kao i opremljena kuhinja. Terasa kuće gleda na okolne vrhove, dajući ovom smještaju posebnu čar.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405016/4._Sobe_Vu%C4%8Deti%C4%87_x7x81u.jpg",
    imageAlt: "Sobe Vučetić planinska kuća sa terasom i pogledom na vrhove Prokletija",
    price: 30,
    priceUnit: "night",
    availability: "available",
    rating: 4.5,
    reviewCount: 44,
    features: ["12 kreveta", "3 spavaće sobe", "Terasa sa pogledom", "Opremljena kuhinja"],
    certifications: ["Planinska kuća", "Prokletije"],
    phone: "+382 67 557 125",
    email: "nikola.vucetic@hotmail.com",
    website: null,
    gps: "42.52244718424369, 19.787088070653674"
  },
  {
    id: 43,
    name: "Eko katun Maja Karanfil",
    category: "accommodation",
    location: "Dolina Grebaje, Gusinje, Montenegro",
    trail: "od-glecera-do-grebaje",
    trailName: "Od glečera do Grebaje",
    description: "Kompleks Maja Karanfil se nalazi na samom raskršću planinarskih staza koje vode do atraktivnih prokletijskih vrhova. Pored smještaja, koji je obezbijeđen u obliku višekrevetnih bungalova, Maja Karanfil ima i restoran u kojem se služe jela nacionalne kuhinje. U ljetnjim mjesecima je otvorena terasa restorana sa fantastičnim pogledom na okolinu.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405018/5._Eko_katun_Maja_Karanfil_b2lld3.jpg",
    imageAlt: "Eko katun Maja Karanfil na raskršću planinarskih staza sa terasom",
    price: 34,
    priceUnit: "night",
    availability: "available",
    rating: 4.8,
    reviewCount: 82,
    features: ["Raskršće staza", "Višekrevetni bungalovi", "Terasa restorana", "Prokletijski vrhovi"],
    certifications: ["Eko katun", "Planinarske staze"],
    phone: "+382 67 651 771",
    email: "majakaranfil@grebaje.me",
    website: null,
    gps: "42.521892169729924, 19.786834547928024"
  },
  {
    id: 44,
    name: "Planinarski dom Branko Kotlajić",
    category: "accommodation",
    location: "Dolina Grebaje, Gusinje, Montenegro",
    trail: "od-glecera-do-grebaje",
    trailName: "Od glečera do Grebaje",
    description: "Planinarski dom 'Branko Kotlajić' je sagrađen 1964. godine i u vlasništvu je planinarskog kluba 'Radnički' iz Beograda. Dom se nalazi na 1175 metara nadmorske visine i kao renoviran ima ukupno 40 raspoloživih mjesta za prenoćište. Na prvom spratu se nalaze dvije spavaone sa ukupno 20 ležaja, dok se u potkrovlju nalazi zajednička spavaona sa 20 mjesta.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405018/6._Planinarski_dom_Branko_Kotlaji%C4%87_vatpw8.jpg",
    imageAlt: "Planinarski dom Branko Kotlajić iz 1964. godine na 1175m visine",
    price: 15,
    priceUnit: "night",
    availability: "available",
    rating: 4.3,
    reviewCount: 98,
    features: ["Od 1964.", "1175m n.v.", "40 ležajeva", "PK Radnički"],
    certifications: ["Renoviran", "Planinarski klub"],
    phone: "+381 64 11 11 303",
    email: "info@pk-radnicki.rs",
    website: null,
    gps: "42.521213202243516, 19.785038251921623"
  },
  {
    id: 45,
    name: "Domaćinstvo Šarkinović",
    category: "local-products",
    location: "Visitorska 51, Brezojevice, Plav, Montenegro",
    trail: "od-glecera-do-grebaje",
    trailName: "Od glečera do Grebaje",
    description: "Nanose koje rijeka Ljuča donosi na Plavsko jezero, inžinjer hemije po struci, a i poljoprivrednih zadnjih 20 godina, Dževat Šarkinović je iskoristio kako bi dobio kvalitetno zemljište koje se pokazalo kao izuzetno produktivno. Pored standardnih poljoprivrednih kultura koje uspijevaju na ovom podneblju, Dževat se odlučio na eksperiment i zasadio kulture poput lubenice, paprike, banane, smokve, grožđe i breskve. Ono što jeste jako zanimljivo je to što Dževat ove kulture gaji na 910 metara nadmorske visine.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405020/7._Doma%C4%87instvo_%C5%A0arkinovi%C4%87_rxkjvc.jpg",
    imageAlt: "Domaćinstvo Šarkinović sa eksperimentalnim kulturama na 910m visine",
    price: 12,
    priceUnit: "item",
    availability: "available",
    rating: 4.9,
    reviewCount: 35,
    features: ["910m n.v.", "Eksperimentalne kulture", "Lubenice", "20 godina iskustva"],
    certifications: ["Inžinjer hemije", "Inovativna poljoprivreda"],
    phone: "+382 69 251 079",
    email: null,
    website: null,
    gps: "42.587991705919066, 19.90881512059775"
  },
  {
    id: 46,
    name: "Botanička bašta Velemun",
    category: "local-products",
    location: "selo Brezojevice, Plav, Montenegro",
    trail: "od-glecera-do-grebaje",
    trailName: "Od glečera do Grebaje",
    description: "Botaničar Milutin Praščević koji je stvorio ovu botaničku baštu još prije 20 godina, za posjetioce brižljivo predstavlja preko 350 biljnih vrsta koji su dio njegove zbirke. Bašta 'Velemun' predstavlja u malom spakovan skoro sav biljni svijet Prokletija. Bašta se nalazi tik uz magistralni put, na 2 km prije ulaza u Plav. Milutin godinama sarađuje sa Institutom za proučavanje ljekovitog bilja 'Dr Josif Pančić', beogradskim Hemijskim i Farmaceutskim fakultetom i Prirodnjačkim muzejom Crne Gore.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405020/8._Botani%C4%8Dka_ba%C5%A1ta_Velemun_yx1nzb.jpg",
    imageAlt: "Botanička bašta Velemun sa preko 350 biljnih vrsta Prokletija",
    price: 5,
    priceUnit: "visit",
    availability: "available",
    rating: 4.8,
    reviewCount: 127,
    features: ["350+ vrsta", "20 godina rada", "Prokletije u malom", "Naučna saradnja"],
    certifications: ["Institut Pančić", "Prirodnjački muzej"],
    phone: "+382 69 470 022",
    email: "velemunhouse@hotmail.com",
    website: null,
    gps: "42.61559986059601, 19.92577501754678"
  },
  {
    id: 47,
    name: "Kamp Lakeviews",
    category: "accommodation",
    location: "Rudo polje, Plav, Montenegro",
    trail: "od-glecera-do-grebaje",
    trailName: "Od glečera do Grebaje",
    description: "Za sve ljubitelje kampovanja i boravka na otvorenom, tu je kamp Lakeviews koji se nalazi na samom ulasku u grad Plav i koji je otvoren 2013. godine. Nalazi se nedaleko od obale Plavskog jezera, a u samom kampu se može smjestiti 150 osoba. Prostrano područje kampa obuhvata i dio na kojem se nalaze tuševi i toalet, a za goste koji više vole da budu smješteni u apartmanima, porodica Martić nudi smještajni kapacitet od ukupno 45 ležajeva.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405022/9._Kamp_Lakeviews_wbumpi.jpg",
    imageAlt: "Kamp Lakeviews na ulasku u Plav sa kapacitetom za 150 osoba",
    price: 20,
    priceUnit: "night",
    availability: "available",
    rating: 4.4,
    reviewCount: 112,
    features: ["150 osoba", "45 ležajeva apartmani", "Plavsko jezero", "Od 2013."],
    certifications: ["Porodica Martić", "Kamp smještaj"],
    phone: "+382 67 672 683",
    email: null,
    website: null,
    gps: "42.60583819439146, 19.930418132775625"
  },

  // Staza 4 - "U zagrljaju šume i tri jezera"
  {
    id: 48,
    name: "Auto kamp Ivan Do",
    category: "accommodation",
    location: "Pitomine bb, Žabljak, Montenegro",
    trail: "u-zagrljaju-sume",
    trailName: "U zagrljaju šume i tri jezera",
    description: "Kamp Ivan do se nalazi na 2 kilometra od centra Žabljaka, na 1500 metara nadmorske visine, u srcu Nacionalnog parka Durmitor. Kamp je opremljen priključcima za kampere i kamp prikolice, a imanje je pogodno i za posjetioce sa šatorima. Osnovni sanitarni čvorovi su obezbijeđeni. Kamp se nalazi u blizini planinarskih i biciklističkih staza, a atrakcije u blizini su Crno, Barno, Jablan i Zminje jezero, kao i selo Bosača koje se smatra najljepšim selom na Žabljaku.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405228/1._Auto_kamp_Ivan_Do_iptrew.jpg ",
    imageAlt: "Auto kamp Ivan Do u Nacionalnom parku Durmitor na 1500m nadmorske visine",
    price: 22,
    priceUnit: "night",
    availability: "available",
    rating: 4.4,
    reviewCount: 156,
    features: ["1500m n.v.", "Sanitarni čvorovi", "4 jezera u blizini", "Biciklističke staze"],
    certifications: ["NP Durmitor", "Auto kamp"],
    phone: "+382 69 041 749",
    email: null,
    website: null,
    gps: "43.15292653553223, 19.097880832602375"
  },
  {
    id: 49,
    name: "Auto kamp Mlinski potok",
    category: "accommodation",
    location: "Pitomine bb, Žabljak, Montenegro",
    trail: "u-zagrljaju-sume",
    trailName: "U zagrljaju šume i tri jezera",
    description: "Auto kamp Mlinski potok se nalazi na 2 km od centra Žabljaka, u nacionalnom parku Durmitor, a udaljen je svega 15 minuta hoda od Crnog jezera. Površina za kampovanje obuhvata 1000 kvadratnih metara. Kamp posjeduje toalete, tuševe sa toplom vodom, kuhinju za samoposluživanje. Za kampere su obezbijeđeni priključci za električnu energiju i sanitarni uređaji za odlaganje otpadnih voda.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405229/2._Auto_kamp_Mlinski_potok_ak8jls.jpg",
    imageAlt: "Auto kamp Mlinski potok na 15 minuta hoda od Crnog jezera",
    price: 25,
    priceUnit: "night",
    availability: "available",
    rating: 4.6,
    reviewCount: 134,
    features: ["1000m² prostora", "15min do Crnog jezera", "Topla voda", "Priključci"],
    certifications: ["NP Durmitor", "Samoposluživanje"],
    phone: "+382 69 821 730",
    email: "minakamp@gmail.com",
    website: "https://autocampmlinskipotok.com",
    gps: "43.15509449310689, 19.100472020730614"
  },
  {
    id: 50,
    name: "Smještaj Durmitor raft",
    category: "accommodation",
    location: "selo Bosača, Žabljak, Montenegro",
    trail: "u-zagrljaju-sume",
    trailName: "U zagrljaju šume i tri jezera",
    description: "Smještaj se nalazi u selu Bosača, koje je najviše stalno naseljeno mjeto na Balkanu. Selo je okruženo četinarskom šumom sa pogledom na vrhove Durmitora, a u neposrednoj blizini se nalaze Crno, Barno i Zminje jezero. Trokrevetne sobe sa kupatilom su opremljene i centralnim grijanjem. Postoji mogućnost dogovora oko pripreme tradicionalnog doručka.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405230/3._Smje%C5%A1taj_Durmitor_raft_g8l4wu.jpg",
    imageAlt: "Smještaj Durmitor raft u najviše naseljenom mjestu na Balkanu",
    price: 35,
    priceUnit: "night",
    availability: "available",
    rating: 4.5,
    reviewCount: 87,
    features: ["Najviše stalno naseljeno", "Četinarska šuma", "3 jezera", "Centralno grijanje"],
    certifications: ["Selo Bosača", "Rafting aktivnosti"],
    phone: "+382 68 001 150",
    email: "durmitorraft@yahoo.com",
    website: "https://durmitorraft.com",
    gps: "43.16218029699239, 19.087711768693836"
  },
  {
    id: 51,
    name: "Bosački konaci",
    category: "accommodation",
    location: "selo Bosača, Žabljak, Montenegro",
    trail: "u-zagrljaju-sume",
    trailName: "U zagrljaju šume i tri jezera",
    description: "Bosačke konake predstavljaju dvije planinske kućice, 'Vila Hana' i 'Vila Dunja' koje se nalaze u selu Bosača, na pet kilometara od centra Žabljaka. Kućice su dvosobne i u njima se mogu smjestiti do četiri osobe. Smještaj je kompletno opremljen, a dozvoljeno je i dovođenje kućnih ljubimaca. U neposrednoj blizini ovog smještaja se nalaze Jablan, Barno i Crno jezero.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405231/4._Bosa%C4%8Dki_konaci_tqmh1r.jpg ",
    imageAlt: "Bosački konaci sa vilama Hana i Dunja u selu Bosača",
    price: 40,
    priceUnit: "night",
    availability: "available",
    rating: 4.7,
    reviewCount: 63,
    features: ["2 planinske kućice", "Do 4 osobe", "Kućni ljubimci", "3 jezera u blizini"],
    certifications: ["Vila Hana i Dunja", "Pet friendly"],
    phone: "+382 68 505 500",
    email: null,
    website: null,
    gps: "43.16640328879644, 19.087304622579403"
  },
  {
    id: 52,
    name: "Apartmani Šibalić",
    category: "accommodation",
    location: "Pitomine bb, Žabljak, Montenegro",
    trail: "u-zagrljaju-sume",
    trailName: "U zagrljaju šume i tri jezera",
    description: "Objekat nudi smještaj sa korišćenjem vrta i terasom, a nalazi se na Žabljaku, nedaleko od Crnog jezera. Ovaj apartman u prizemlju ima jednu spavaću sobu, flat-screen TV sa satelitskim kanalima i potpuno opremljenu kuhinju sa svim elementima. Ponuda apartmana uključuje uslugu iznajmljivanja bicikala.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405232/5._Apartmani_%C5%A0ibali%C4%87_zsuvyp.jpg",
    imageAlt: "Apartmani Šibalić sa vrtom i terasom blizu Crnog jezera",
    price: 45,
    priceUnit: "night",
    availability: "available",
    rating: 4.3,
    reviewCount: 71,
    features: ["Vrt i terasa", "Flat-screen TV", "Opremljena kuhinja", "Iznajmljivanje bicikala"],
    certifications: ["Satelitski kanali", "Blizu Crnog jezera"],
    phone: "+382 69 223 433",
    email: "milicasibalic1111@gmail.com",
    website: null,
    gps: "43.157158322231936, 19.097775020365173"
  },
  {
    id: 53,
    name: "Apartmani Durmitor",
    category: "accommodation",
    location: "Pitomine bb, Žabljak, Montenegro",
    trail: "u-zagrljaju-sume",
    trailName: "U zagrljaju šume i tri jezera",
    description: "Apartmani Durmitor se nalaze u selu Pitomine, na 1,5 km od Crnog jezera. Udobni apartmani su kompletno opremljeni, sa zajedničkom kuhinjom koja je dostupna za korišćenje. U dogovoru sa domaćinima, moguće je organizovati aktivnosti poput jahanja, planinarenja, vožnja bicikala itd.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405233/6._Apartmani_Durmitor_atnpjy.jpg",
    imageAlt: "Apartmani Durmitor u selu Pitomine sa zajedničkom kuhinjom",
    price: 42,
    priceUnit: "night",
    availability: "available",
    rating: 4.4,
    reviewCount: 89,
    features: ["1,5km od Crnog jezera", "Zajednička kuhinja", "Jahanje", "Planinarenje"],
    certifications: ["Selo Pitomine", "Aktivni turizam"],
    phone: "+382 67 555 616",
    email: "apartmandurmitor@hotmail.com",
    website: null,
    gps: "43.15555116183214, 19.10066697343457"
  },
  {
    id: 54,
    name: "Mićun Karadžić",
    category: "local-products",
    location: "Ulica Narodnih heroja 32, Žabljak, Montenegro",
    trail: "u-zagrljaju-sume",
    trailName: "U zagrljaju šume i tri jezera",
    description: "Mićun Karadžić pravi gusle aktivno zadnjih 20 godina, od javorovog drveta. Sve je ručni rad, za gudalo se isključivo koristi konjska dlaka, a postoji duga porodična tradicija rada sa drvetom. Na guslama se nalaze uvijek crnogorski motivi: Njegoš, Marko Miljanov, grb, pejzaž Durmitora itd.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405235/7._Mi%C4%87un_Karad%C5%BEi%C4%87_lsoxgc.jpg ",
    imageAlt: "Mićun Karadžić sa ručno rađenim guslama od javorovog drveta",
    price: 150,
    priceUnit: "item",
    availability: "available",
    rating: 4.9,
    reviewCount: 23,
    features: ["20 godina iskustva", "Javorovo drvo", "Konjska dlaka", "Crnogorski motivi"],
    certifications: ["Ručni rad", "Porodična tradicija"],
    phone: "+382 69 223 221",
    email: null,
    website: null,
    gps: "43.157474375286576, 19.122377014338056"
  },
  {
    id: 55,
    name: "Branka Pajović",
    category: "local-products",
    location: "Novakovići bb, Žabljak, Montenegro",
    trail: "u-zagrljaju-sume",
    trailName: "U zagrljaju šume i tri jezera",
    description: "Branku, jednu od dvije harfistkinje u Crnoj Gori, pored toga što svira ovaj jako rijedak instrument, bavi se još jednim poslom. Iako zvuci njene keltske harfe u ambijentu Durmitora stvaraju magiju, njene ruke kreiraju još jednu umjetnost. Branka pravi suvenire i umjetničke slike od vune, predstavljajući tako Durmitor na jedan drugačiji način. Njene unikatne slike sa Durmitorskim motivima kreirane od vune i oslikane bojama ovog kraja, predstavljaju autentičan suvenir koji valja ponijeti sa sobom.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405235/8._Branka_Pajovi%C4%87_iztnyu.jpg",
    imageAlt: "Branka Pajović sa keltskom harfom i umjetničkim slikama od vune",
    price: 80,
    priceUnit: "item",
    availability: "available",
    rating: 4.8,
    reviewCount: 31,
    features: ["Keltska harfa", "Jedna od dvije", "Slike od vune", "Durmitorski motivi"],
    certifications: ["Rijedak instrument", "Unikatni suveniri"],
    phone: "+382 67 654 928",
    email: null,
    website: null,
    gps: "43.09120974331274, 19.162735856716225"
  },
  {
    id: 56,
    name: "Milovan Kalpačina",
    category: "local-products",
    location: "Vrela bb, Žabljak, Montenegro",
    trail: "u-zagrljaju-sume",
    trailName: "U zagrljaju šume i tri jezera",
    description: "Iako pčelarstvo doživljava kao hobi, razgovor sa domaćinom otkriva njegovu veliku ljubav prema pčelama, a degustacija meda iz košnica potvrdiće da su za kvalitet proizvoda presudne upravo njegova posvećenost i preciznost u radu. Kroz Milovanove priče o prirodnim ljepotama, ali ujedno i surovosti uslova za život, Pirlitoru i ostalim tekovinama burne istorije kraja, o ljudima i načinu života ranije - kako on pamti i kako su mu stari prenijeli u pričama, gosti mogu otkriti njegovu privrženost i ljubav prema zavičaju.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405237/9._Milovan_Kalpa%C4%8Dina_epjirc.jpg",
    imageAlt: "Milovan Kalpačina sa pčelinjacima i proizvodima od meda na štandu",
    price: 18,
    priceUnit: "item",
    availability: "available",
    rating: 4.7,
    reviewCount: 45,
    features: ["Pčelarstvo kao hobi", "Med u saću", "Med sa voćem", "Štand na putu"],
    certifications: ["Kvalitetni proizvodi", "Priče o zavičaju"],
    phone: "+382 69 458 784",
    email: null,
    website: null,
    gps: "43.15471865435172, 19.215868257720757"
  },
  {
    id: 57,
    name: "Stanko Ostojić",
    category: "local-products",
    location: "Vrela bb, Žabljak, Montenegro",
    trail: "u-zagrljaju-sume",
    trailName: "U zagrljaju šume i tri jezera",
    description: "Zanimljivo je krstarenje pričama kroz tradiciju ovoga kraja kojim se sa domaćinom stiže i do njegovog bavljenja pčelarstvom kao dijelom porodičnog nasljeđa. Sa ponosom Stanko ističe osobenosti meda sa područja Durmitora i napora pčelara da uprkos značajnim variranjima u temperaturi vazduha tokom godine uspiju da očuvaju zdravlje pčela i postignu visok kvalitet meda. To je jedino moguće uz veliki entuzijazam i ljubav prema pčelama. Specifičnu aromu meda nagovještava sam pogled na okruženje gdje se nalazi Stankov pčelinjak.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405240/10._Stanko_Ostoji%C4%87_mo0ztw.jpg",
    imageAlt: "Stanko Ostojić sa pčelinjacima i čajevima u ambijentu Durmitora",
    price: 20,
    priceUnit: "item",
    availability: "available",
    rating: 4.6,
    reviewCount: 52,
    features: ["Porodično nasljeđe", "Durmitorski med", "Čajevi iz prirode", "Temperature varijacije"],
    certifications: ["Entuzijazam i ljubav", "Visok kvalitet"],
    phone: "+382 67 623 102",
    email: null,
    website: null,
    gps: "43.1531850586673, 19.21556924944179"
  },
  {
    id: 58,
    name: "Radovan Dragan Simićević",
    category: "local-products",
    location: "selo Gomile, Žabljak, Montenegro",
    trail: "u-zagrljaju-sume",
    trailName: "U zagrljaju šume i tri jezera",
    description: "Pčelarstvo je za Dragana u početku bio hobi, a danas njegova pasija. On se bavi i stočarstvom i sa bratom održava tradiciju katunskog načina života. Prije ručka, gosti degustiraju med uz borovnice. Potom domaćini serviraju: saljevak, skorup, sir, kisjelo mlijeko, pršut, a mogu poslužiti i jareći košet i jomužu – piće od mlijeka sa snijegom. Odraz tradicije je i kolač patišpanj koji gosti po želji mogu preliti sa medom i posuti borovnicama. Simićevići nude uslugu smještaja i kampovanja.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405241/11._Radovan_Dragan_Simi%C4%87evi%C4%87_vprcxz.jpg",
    imageAlt: "Radovan Dragan Simićević sa tradicionalnim proizvodima i katunskim načinom života",
    price: 25,
    priceUnit: "meal",
    availability: "available",
    rating: 4.8,
    reviewCount: 39,
    features: ["Katunski način života", "Med uz borovnice", "Jareći košet", "Patišpanj"],
    certifications: ["Tradicionalni proizvodi", "Smještaj i kampovanje"],
    phone: "+382 69 477 846",
    email: null,
    website: null,
    gps: "43.0474422443306, 19.328423084310636"
  },
  {
    id: 59,
    name: "Nacionalni restoran Crno jezero",
    category: "hospitality",
    location: "Crno jezero, Žabljak, Montenegro",
    trail: "u-zagrljaju-sume",
    trailName: "U zagrljaju šume i tri jezera",
    description: "Nacionalni restoran Crno jezero se nalazi na samoj obali istoimenog jezera. Dizajniran u skladu sa prirodom koja ga okružuje, sa fantastičnim pogledom na jezero, restoran nudi specijalitete nacionalne kuhinje kao i karakteristična crnogorska pića, alkoholna i bezalkoholna. Restoran se nalazi odmah pored staze koja vodi oko jezera, te može poslužiti kao mjesto za odmor nakon šetnje.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405244/12._Nacionalni_restoran_Crno_jezero_ngege9.jpg",
    imageAlt: "Nacionalni restoran Crno jezero na obali jezera sa pogledom na vodu",
    price: 22,
    priceUnit: "meal",
    availability: "available",
    rating: 4.5,
    reviewCount: 187,
    features: ["Obala jezera", "Fantastičan pogled", "Crnogorska pića", "Pored staze"],
    certifications: ["Nacionalna kuhinja", "Dizajn u skladu sa prirodom"],
    phone: "+382 67 040 425",
    email: "info@restorancrnojezero.me",
    website: "https://www.restorancrnojezero.me",
    gps: "43.147479793838755, 19.097457186862396"
  },
  {
    id: 60,
    name: "Domaćinstvo Krejović",
    category: "local-products",
    location: "Borje bb, Žabljak, Montenegro",
    trail: "u-zagrljaju-sume",
    trailName: "U zagrljaju šume i tri jezera",
    description: "Domaćinstvo Krejović živi u selu Borje, koje je samo par stotina metara udaljeno od skretanja sa magistralnog puta za Pirlitor. U njihovom prostranom zelenom dvorištu ljubitelji kampovanja su dobrodošli. Ono što treba da probate je domaće suvo meso i sirevi, a posebno domaći trapist po kome je domaćica izuzetno cijenjena.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405245/13._Doma%C4%87instvo_Krejovi%C4%87_qhb4zy.jpg ",
    imageAlt: "Domaćinstvo Krejović u selu Borje sa dvorištem za kampovanje",
    price: 16,
    priceUnit: "item",
    availability: "available",
    rating: 4.7,
    reviewCount: 28,
    features: ["Selo Borje", "Prostrano dvorište", "Domaći trapist", "Suvo meso"],
    certifications: ["Cijenjena domaćica", "Kampovanje dobrodošlo"],
    phone: "+382 67 344 237",
    email: "tanjakrejovic93@gmail.com",
    website: null,
    gps: "43.166334022789385, 19.183978929305585"
  },
  {
    id: 61,
    name: "Domaćinstvo Kaljević",
    category: "accommodation",
    location: "Podgora bb, Žabljak, Montenegro",
    trail: "u-zagrljaju-sume",
    trailName: "U zagrljaju šume i tri jezera",
    description: "Kako bi Vam dočarali duh starih vremena, Kaljevići za svoje goste organizuju muzičke večeri sa folklorom u crnogorskoj narodnoj nošnji, uz muziku na tradicionalnim instrumentima, guslama i sviralama. Za ljubitelje boravka u prirodi, ovo domaćinstvo može pripremiti ture jahanja konja ili oprobavanje u viteškim igrama uz vatru na otvorenom. Za one željne spavanja u planinskom ambijentu 'pod gorom' (odatle i ime sela, okruženo šumom), tu je drvena koliba kao i komforne dvokrevetne i trokrevetne sobe ukupnog kapaciteta 10 osoba.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405248/14._Doma%C4%87instvo_Kaljevi%C4%87_hpwlqi.jpg",
    imageAlt: "Domaćinstvo Kaljević sa tradicionalnim instrumentima i viteškim igrama",
    price: 32,
    priceUnit: "night",
    availability: "available",
    rating: 4.9,
    reviewCount: 24,
    features: ["Folklorne večeri", "Jahanje konja", "Viteške igre", "10 osoba kapacitet"],
    certifications: ["Tradicionalni instrumenti", "Drvena koliba"],
    phone: "+382 67 024 044",
    email: "laki.k@t-com.me",
    website: null,
    gps: "43.19758937073753, 19.145822468712353"
  },
  {
    id: 62,
    name: "Chalets Pod Gorom",
    category: "accommodation",
    location: "Njegovuđa, Žabljak, Montenegro",
    trail: "u-zagrljaju-sume",
    trailName: "U zagrljaju šume i tri jezera",
    description: "U ovom eko kampu možete pronaći smještaj u udobnim bungalovima, a pravu atrakciju predstavlja porodična kuća koja je izgrađena na jedinstven način. Po želji gostiju, domaćinstvo pruža i uslugu hrane. Domaćin je dobar poznavalac okoline, pa za sve zainteresovane goste, može organizovati i razne izlete. Ovo domaćinstvo živi u Njegovuđi tokom cijele godine.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763405248/15._Chalets_Pod_Gorom_tab636.jpg",
    imageAlt: "Chalets Pod Gorom sa jedinstveno izgrađenom porodičnom kućom",
    price: 38,
    priceUnit: "night",
    availability: "available",
    rating: 4.6,
    reviewCount: 47,
    features: ["Udobni bungalovi", "Jedinstvena kuća", "Poznavalac okoline", "Cijelu godinu"],
    certifications: ["Eko kamp", "Organizovani izleti"],
    phone: "+382 67 344 721",
    email: "chaletspodgorom@t-com.me",
    website: null,
    gps: "43.11881602109852, 19.218032655960872"
  },

  // Serbian Trails Tourism Offerings

  // Staza 5 - "Život kroz vekove – Stanovništvo Golije"
  {
    id: 63,
    name: "Etno kuća Milića",
    category: "accommodation",
    location: "selo Rudno, Golija, Serbia",
    trail: "zivot-kroz-vekove-golija",
    trailName: "Život kroz vekove – Stanovništvo Golije",
    description: "Etno kuća Milića u selu Rudno predstavlja autentično iskustvo života na Goliji. Kuća je izgrađena u tradicionalnom stilu sa drvetom iz okolnih šuma. Gosti mogu učestvovati u svakodnevnim aktivnostima domaćinstva - muženju krava, spravljanju sira, pečenju hleba pod sačem. U ponudi su domaći proizvodi kao što su kajmak, sir, pršut i rakije od lokalnog voća.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d3c57f8d-1763510078405.png",
    imageAlt: "Etno kuća Milića sa tradicionalnom arhitekturom i dvorištem u selu Rudno na Goliji",
    price: 35,
    priceUnit: "night",
    availability: "available",
    rating: 4.8,
    reviewCount: 47,
    features: ["Tradicionalna kuća", "Domaći proizvodi", "Muža krava", "Hleb pod sačem"],
    certifications: ["Etno turizam", "Tradicionalno domaćinstvo"],
    phone: "+381 64 123 4567",
    email: "etnokuča.milića@gmail.com",
    website: null,
    gps: "43.38056, 20.24833"
  },
  {
    id: 64,
    name: "Planinarski dom Golija",
    category: "accommodation",
    location: "Golija, Ivanjica, Serbia",
    trail: "zivot-kroz-vekove-golija",
    trailName: "Život kroz vekove – Stanovništvo Golije",
    description: "Planinarski dom na 1650m nadmorske visine u srcu Nacionalnog parka Golija. Dom pruža smeštaj za 40 osoba u spavaonicama sa po 4-8 kreveta. U ponudi su doručak i večera sa specialitetima lokalne kuhinje. Dom je polazište za mnoge planinarske staze i vidikovce Golije kao što su Jankov kamen i Košaninova jezera.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c7517bc7-1763510080922.png",
    imageAlt: "Planinarski dom Golija na 1650m visine okružen planinarskim pejzažima",
    price: 20,
    priceUnit: "night",
    availability: "available",
    rating: 4.5,
    reviewCount: 89,
    features: ["1650m n.v.", "40 ležajeva", "Planinarske staze", "Lokalna kuhinja"],
    certifications: ["Planinarski savez Srbije", "NP Golija"],
    phone: "+381 32 664 200",
    email: "dom.golija@pss.rs",
    website: "https://planinarskisavez.rs",
    gps: "43.38347, 20.25611"
  },
  {
    id: 65,
    name: "Restoran Golijska čaršija",
    category: "hospitality",
    location: "Ivanjica, Serbia",
    trail: "zivot-kroz-vekove-golija",
    trailName: "Život kroz vekove – Stanovništvo Golije",
    description: "Tradicionalni restoran u centru Ivanjice koji neguje kuhinju Golije. Specijalteti uključuju janjeće pečenje, kačamak, gibanicu, komplete sa mesom ispod sača i sir iz ovčjeg mleka. Restoran koristi samo lokalne namirnice od sertifikovanih proizvođača sa Golije i okoline.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c183990d-1763510080900.png",
    imageAlt: "Restoran Golijska čaršija sa tradicionalnim ambijentom i lokalnim specijalitetima",
    price: 15,
    priceUnit: "meal",
    availability: "available",
    rating: 4.6,
    reviewCount: 134,
    features: ["Janjeće pečenje", "Kačamak", "Lokalni proizvodi", "Tradicionalni ambijent"],
    certifications: ["Tradicionalna kuhinja", "Lokalni proizvođači"],
    phone: "+381 32 661 789",
    email: "golijska.čaršija@restoran.rs",
    website: null,
    gps: "43.58194, 20.22806"
  },
  {
    id: 66,
    name: "Pčelarstvo Jovanovića",
    category: "local-products",
    location: "selo Biniće, Golija, Serbia",
    trail: "zivot-kroz-vekove-golija",
    trailName: "Život kroz vekove – Stanovništvo Golije",
    description: "Porodična tradicija pčelarstva traje već tri generacije. Na imanju se nalazi 120 košnica koje daju godišnje preko 2 tone kvalitetnog planinarskog medu. Pored medu, prodaju se propolis, vosak, polen i medenjaci pravljeni po staroj recepturi. Gosti mogu posmatrati rad u pčelinjaku i degustirati različite vrste meda.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_19f04e093-1763510077687.png",
    imageAlt: "Pčelarstvo Jovanovića sa košnicama na livadama Golije i planinskim medom",
    price: 18,
    priceUnit: "item",
    availability: "available",
    rating: 4.9,
    reviewCount: 62,
    features: ["120 košnica", "2+ tone meda", "3 generacije", "Degustacija"],
    certifications: ["Organski proizvodi", "Tradicionalno pčelarstvo"],
    phone: "+381 64 987 6543",
    email: "jovanović.pčelarstvo@golija.rs",
    website: null,
    gps: "43.36722, 20.23889"
  },
  {
    id: 67,
    name: "Seosko domaćinstvo Petrovića",
    category: "local-products",
    location: "selo Rudno, Golija, Serbia",
    trail: "zivot-kroz-vekove-golija",
    trailName: "Život kroz vekove – Stanovništvo Golije",
    description: "Tradicionalno seosko domaćinstvo koje se bavi stočarstvom i proizvodnjom mlečnih proizvoda. Na imanju se drži 25 krava i 40 ovaca. Proizvodi se sir, kajmak, skorup i kiselo mleko po staroj recepturi. Gosti mogu učestvovati u muženju, spravljanju sira i drugim aktivnostima vezanim za zemljoradnju.",
    image: "https://images.unsplash.com/photo-1649187642490-c1baa69d27fa",
    imageAlt: "Seosko domaćinstvo Petrovića sa kravama i tradicionalnim mlečnim proizvodima",
    price: 12,
    priceUnit: "item",
    availability: "available",
    rating: 4.7,
    reviewCount: 38,
    features: ["25 krava, 40 ovaca", "Tradiconalni sir", "Učešće u muženju", "Stara receptura"],
    certifications: ["Seosko domaćinstvo", "Tradicionalna proizvodnja"],
    phone: "+381 64 555 7890",
    email: null,
    website: null,
    gps: "43.37944, 20.24167"
  },

  // Staza 6 - "Osluškujući damare srednjovekovne Srbije – Nemanjićevim nasleđem"
  {
    id: 68,
    name: "Manastirski konak Studenica",
    category: "accommodation",
    location: "Manastir Studenica, Kraljevo, Serbia",
    trail: "listening-to-medieval-serbia",
    trailName: "Osluškujući damare srednjovekovne Srbije – Nemanjićevim nasleđem",
    description: "Smeštaj u okviru manastirskog kompleksa Studenica, UNESCO spomenika svetske baštine. Konak pruža jednostavan ali dostojanstven smeštaj za hodočasnike i posetioce. Jutarnje i večernje molitve mogu se pratiti u crkvi. U ponudi su manastirski proizvodi kao što su med, čajevi od lekovitog bilja i rukotvorine.",
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763456469/2.14.JPG_mini_txkkqf.jpg",
    imageAlt: "Manastirski konak Studenica sa belim zidovima u ambijentu UNESCO spomenika",
    price: 25,
    priceUnit: "night",
    availability: "available",
    rating: 4.8,
    reviewCount: 156,
    features: ["UNESCO spomenik", "Manastirski proizvodi", "Duhovni turizam", "Hodočašće"],
    certifications: ["UNESCO", "Srpska pravoslavna crkva"],
    phone: "+381 36 5568 006",
    email: "studenica@spc.rs",
    website: "https://manastirstudenica.rs",
    gps: "43.48889, 20.53167"
  },
  {
    id: 69,
    name: "Vila Nemanjić",
    category: "accommodation",
    location: "Ušće, Kraljevo, Serbia",
    trail: "listening-to-medieval-serbia",
    trailName: "Osluškujući damare srednjovekovne Srbije – Nemanjićevim nasleđem",
    description: "Boutique hotel u tradicionalnom stilu posvećen dinastiji Nemanjića. Sobe su imenovane po srpskim vladarima i opremljene autentičnim nameštajem. Hotel organizuje istorijske ture, konjičke vožnje i posete manastirima. U restoranu se služe jela po recepturama iz srednjeg veka.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d97a4a41-1763510079614.png",
    imageAlt: "Vila Nemanjić sa tradicionalnom arhitekturom i istorijskim ambijentom",
    price: 65,
    priceUnit: "night",
    availability: "available",
    rating: 4.7,
    reviewCount: 91,
    features: ["Istorijske ture", "Konjičke vožnje", "Srednjovekovna kuhinja", "Boutique hotel"],
    certifications: ["Boutique hotel", "Kulturni turizam"],
    phone: "+381 36 399 100",
    email: "reservations@vilanemanjiс.rs",
    website: "https://vilanemanjiс.rs",
    gps: "43.52222, 20.54444"
  },
  {
    id: 70,
    name: "Restoran Nemanjina kuhinja",
    category: "hospitality",
    location: "Kraljevo, Serbia",
    trail: "listening-to-medieval-serbia",
    trailName: "Osluškujući damare srednjovekovne Srbije – Nemanjićevim nasleđem",
    description: "Restoran specijalizovan za srednjovekovnu srpsku kuhinju rekonstruisanu na osnovu istorijskih izvora. Jela se pripremaju po autentičnim recepturama korišćenjem samo prirodnih začina i tradicionalnih metoda kuvanja. Osoblje nosi kostim iz doba Nemanjića, a ambijent podseća na srednjovekovnu gozbu.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1202cb9e2-1763510078621.png",
    imageAlt: "Restoran Nemanjina kuhinja sa srednjovekovnim ambijentom i autentičnim jelima",
    price: 22,
    priceUnit: "meal",
    availability: "available",
    rating: 4.6,
    reviewCount: 178,
    features: ["Srednjovekovna kuhinja", "Autentični recepti", "Kostimi", "Istorijski ambijent"],
    certifications: ["Kulturni turizam", "Istorijska gastronomija"],
    phone: "+381 36 399 200",
    email: "rezervacije@nemanjinskakuhinja.rs",
    website: null,
    gps: "43.72556, 20.68667"
  },
  {
    id: 71,
    name: "Zlatarska radionica Nemanjić",
    category: "local-products",
    location: "Studenica, Kraljevo, Serbia",
    trail: "listening-to-medieval-serbia",
    trailName: "Osluškujući damare srednjovekovne Srbije – Nemanjićevim nasleđem",
    description: "Tradicionalna zlatarska radionica koja rekonstruiše nakit i crkvene predmete iz doba dinastije Nemanjić. Majstori koriste stare tehnike i alate za izradu replika istorijskih ukrasa. Posetioce mogu da prate proces rada i kupe autentične replike srednjovekovnog nakita i liturgijskih predmeta.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_13d1649f3-1763510079715.png",
    imageAlt: "Zlatarska radionica Nemanjić sa tradicionalnim alatima i srednjovekovnim nakitom",
    price: 45,
    priceUnit: "item",
    availability: "available",
    rating: 4.9,
    reviewCount: 23,
    features: ["Tradicionalne tehnike", "Replika nakita", "Srednjovekovni dizajn", "Ručni rad"],
    certifications: ["Zanatska radionica", "Kulturno nasleđe"],
    phone: "+381 36 5568 123",
    email: "zlatara.nemanjiс@traditional.rs",
    website: null,
    gps: "43.48556, 20.53333"
  },

  // Staza 7 - "I BI VODA – Život ljudi u planini i vodi"
  {
    id: 72,
    name: "Vodenica na Brevini",
    category: "local-products",
    location: "Brevina reka, Golija, Serbia",
    trail: "trail-details-and-there-was-water-life-of-people-in-mountains-and-water",
    trailName: "I BI VODA – Život ljudi u planini i vodi",
    description: "Obnovljena tradicionalna vodenica na reci Brevini koja i danas melje žitarice po staroj tehnologiji. Posetioce mogu da prate proces meljave i kupe sveze mlevene proizvode - kukuruzno brašno, pšenično brašno i pahuljice. Vodeničar objašnjava kako funkcioniše vodeni pogon i značaj vodenica u životu lokalnog stanovništva.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_18530d2c9-1763510081890.png",
    imageAlt: "Tradicionalna vodenica na Brevini sa vodenim točkom i kamenim mlinskim kamenjem",
    price: 8,
    priceUnit: "item",
    availability: "available",
    rating: 4.8,
    reviewCount: 67,
    features: ["Tradicionalna tehnologija", "Sveze mleveno", "Vodeni pogon", "Edukativna tura"],
    certifications: ["Kulturno nasleđe", "Tradicionalni zanat"],
    phone: "+381 64 321 9876",
    email: "vodenica.brevina@tradition.rs",
    website: null,
    gps: "43.37333, 20.26222"
  },
  {
    id: 73,
    name: "Kamp kod Brevine",
    category: "accommodation",
    location: "Brevina reka, Golija, Serbia",
    trail: "trail-details-and-there-was-water-life-of-people-in-mountains-and-water",
    trailName: "I BI VODA – Život ljudi u planini i vodi",
    description: "Prirodni kamp na obali reke Brevine u okruženju stoletnjih bukova i smrčeva. Kamp ima mesta za šatore i prikolice, sanitarne čvorove i prostor za pripremu hrane. Gosti mogu pešačiti duž reke, kupati se u prirodnim bazenima i uživati u tišini netaknute prirode. Noću se čuje šum vode i povremeno urlanje jelena.",
    image: "https://images.unsplash.com/photo-1606726769120-4e4d27accab5",
    imageAlt: "Kamp kod Brevine sa šatorima pored reke u šumovitom ambijentu Golije",
    price: 15,
    priceUnit: "night",
    availability: "available",
    rating: 4.6,
    reviewCount: 89,
    features: ["Obala reke", "Prirodni bazeni", "Šumsko okruženje", "Netaknuta priroda"],
    certifications: ["Eko kamp", "Prirodni ambijent"],
    phone: "+381 64 111 2233",
    email: "kampbrevina@nature.rs",
    website: null,
    gps: "43.37111, 20.26444"
  },
  {
    id: 74,
    name: "Izvor Svete Trojice",
    category: "local-products",
    location: "Golija, Ivanjica, Serbia",
    trail: "trail-details-and-there-was-water-life-of-people-in-mountains-and-water",
    trailName: "I BI VODA – Život ljudi u planini i vodi",
    description: "Sveti izvor pored crkve Svete Trojice na Goliji, poznat po svom lečebnom svojstvu. Voda izvire iz dubine planine i održava konstantnu temperaturu tokom cele godine. Lokalno stanovništvo veruje da voda pomaže kod problema sa bubrežima i varanjem. Pored izvora se nalazi manja prodavnica sa flaširanom vodom i suvenirima.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ff2933c0-1763510079032.png",
    imageAlt: "Izvor Svete Trojice sa kristalno čistom vodom i malom crkvom u pozadini",
    price: 3,
    priceUnit: "item",
    availability: "available",
    rating: 4.7,
    reviewCount: 145,
    features: ["Lečebna svojstva", "Konstantna temperatura", "Flaširana voda", "Verski značaj"],
    certifications: ["Prirodni izvor", "Lečebne vode"],
    phone: "+381 32 661 100",
    email: null,
    website: null,
    gps: "43.38500, 20.25750"
  },

  // Staza 8 - "BIO JEDNOM JEDAN – Mitovi i legende ljudi sa planine" 
  {
    id: 75,
    name: "Mitska planina Guest House",
    category: "accommodation",
    location: "Bojovo brdo, Golija, Serbia",
    trail: "trail-details-once-upon-a-time-myths-and-legends-of-mountain-people",
    trailName: "BIO JEDNOM JEDAN – Mitovi i legende ljudi sa planine",
    description: "Jedinstvena gostinska kuća na Bojovom brdu posvećena mitovima i legendama Golije. Svaka soba nosi ime nekog mitskog bića ili junaka iz narodnih predanja. Domaćini organizuju večernje sesije pripovedanja legendi oko logarske vatre, a gosti mogu naručiti 'mitsku večeru' pripremljenu po receptima iz starih vremena.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_175177c60-1763510077474.png",
    imageAlt: "Mitska planina Guest House sa tradicionalnom arhitekturom na Bojovom brdu",
    price: 42,
    priceUnit: "night",
    availability: "available",
    rating: 4.9,
    reviewCount: 73,
    features: ["Pripovedanje legendi", "Mitska večera", "Logarska vatra", "Tematske sobe"],
    certifications: ["Kulturni turizam", "Folklorno nasleđe"],
    phone: "+381 64 777 8899",
    email: "mitska.planina@legends.rs",
    website: "https://mitskaplaninahouse.rs",
    gps: "43.36889, 20.27444"
  },
  {
    id: 76,
    name: "Restoran Jankovo carstvo",
    category: "hospitality",
    location: "podnožje Jankovog kamena, Golija, Serbia",
    trail: "trail-details-once-upon-a-time-myths-and-legends-of-mountain-people",
    trailName: "BIO JEDNOM JEDAN – Mitovi i legende ljudi sa planine",
    description: "Restoran na 1750m nadmorske visine, na podnožju vrha Jankov kamen. Menu je inspirisan legendama o vili Ravijojli i junu Jankovu. Specialiteti uključuju 'Jankovicu' (tradicionalnu čorbu), 'Ravijojlinu salatu' od planskog bilja i 'Božanski nektar' (rakiju od divljih plodova). Sa terase se pruža spektakularan pogled na celu Goliju.",
    image: "https://images.unsplash.com/photo-1677777010379-36a65f9339a5",
    imageAlt: "Restoran Jankovo carstvo na visokoj planini sa panoramskim pogledom na Goliju",
    price: 25,
    priceUnit: "meal",
    availability: "available",
    rating: 4.8,
    reviewCount: 124,
    features: ["1750m n.v.", "Legendarna jela", "Panoramski pogled", "Plansko bilje"],
    certifications: ["Visinski restoran", "Folklorna gastronomija"],
    phone: "+381 32 777 999",
    email: "jankovo.carstvo@mountain.rs",
    website: null,
    gps: "43.36167, 20.27833"
  },
  {
    id: 77,
    name: "Zanatska radionica \'Vila Ravijojla'",
    category: "local-products",
    location: "Moravica, Golija, Serbia",
    trail: "trail-details-once-upon-a-time-myths-and-legends-of-mountain-people",
    trailName: "BIO JEDNOM JEDAN – Mitovi i legende ljudi sa planine",
    description: "Zanatska radionica posvećena izradi predmeta inspirisanih lokalnim legendama. Majstorka pravi ukrasne predmete, amajlije i suvenire koji reprezentuju mitska bića sa Golije. Koriste se prirodni materijali - drvo, kamen, vuna i lekovito bilje. Svaki proizvod dolazi sa pričom o legendi koja ga je inspirisala.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a1835a0a-1763510078017.png",
    imageAlt: "Zanatska radionica Vila Ravijojla sa ručno rađenim predmetima i prirodnim materijalima",
    price: 28,
    priceUnit: "item",
    availability: "available",
    rating: 4.7,
    reviewCount: 45,
    features: ["Ručni rad", "Prirodni materijali", "Legendarne priče", "Amajlije"],
    certifications: ["Zanatska radionica", "Folklorno umeće"],
    phone: "+381 64 333 4455",
    email: "vila.ravijojla@crafts.rs",
    website: null,
    gps: "43.35778, 20.28111"
  },
  {
    id: 78,
    name: "Dajićko jezero bungalovi",
    category: "accommodation",
    location: "Dajićko jezero, Golija, Serbia",
    trail: "trail-details-once-upon-a-time-myths-and-legends-of-mountain-people",
    trailName: "BIO JEDNOM JEDAN – Mitovi i legende ljudi sa planine",
    description: "Ekskluzivni bungalovi na obali mističnog Dajićkog jezera na 1470m visine. Jezero je okruženo legendama o vilama koje se kupaju u mesečini. Bungalovi su izgrađeni od lokalnog kamena i drveta, u harmoniji sa prirodom. Noću se može čuti tajanstvena 'muzika jezera' koju stvara vetar koji se penje iz dubina.",
    image: "https://images.unsplash.com/photo-1727843506559-fdad7e208d62",
    imageAlt: "Bungalovi na obali Dajićkog jezera sa planinama u pozadini i maglovitim ambijentom",
    price: 55,
    priceUnit: "night",
    availability: "available",
    rating: 4.8,
    reviewCount: 67,
    features: ["1470m n.v.", "Obala jezera", "Mistični ambijent", "Prirodni materijali"],
    certifications: ["Eko smeštaj", "Ekskluzivno odmaralište"],
    phone: "+381 64 999 1122",
    email: "dajicko.jezero@mystical.rs",
    website: "https://dajickojezero.rs",
    gps: "43.35000, 20.28500"
  }];

  // Filter offerings based on active filters
  useEffect(() => {
    let filtered = mockOfferings;

    // Filter by category
    if (activeCategory !== 'all') {
      filtered = filtered?.filter((offering) => offering?.category === activeCategory);
    }

    // Filter by trail
    if (selectedTrail !== 'all') {
      filtered = filtered?.filter((offering) => offering?.trail === selectedTrail);
    }

    // Filter by location
    if (selectedLocation !== 'all') {
      if (selectedLocation === 'serbia') {
        filtered = filtered?.filter((offering) => offering?.location?.includes('Serbia'));
      } else if (selectedLocation === 'montenegro') {
        filtered = filtered?.filter((offering) => offering?.location?.includes('Montenegro'));
      } else {
        filtered = filtered?.filter((offering) =>
        offering?.location?.toLowerCase()?.includes(selectedLocation?.replace('-', ' '))
        );
      }
    }

    // Filter by price range
    if (selectedPriceRange !== 'all') {
      const [min, max] = selectedPriceRange?.includes('+') ?
      [parseInt(selectedPriceRange?.replace('+', '')), Infinity] :
      selectedPriceRange?.split('-')?.map((p) => parseInt(p));

      filtered = filtered?.filter((offering) =>
      offering?.price >= min && (max === Infinity || offering?.price <= max)
      );
    }

    setFilteredOfferings(filtered);
  }, [activeCategory, selectedLocation, selectedPriceRange, selectedTrail]);

  // Simulate loading
  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => setIsLoading(false), 800);
    return () => clearTimeout(timer);
  }, [activeCategory, selectedLocation, selectedPriceRange, selectedTrail]);

  const handleCategoryChange = (category) => {
    setActiveCategory(category);
  };

  const handleLocationChange = (location) => {
    setSelectedLocation(location);
  };

  const handlePriceRangeChange = (priceRange) => {
    setSelectedPriceRange(priceRange);
  };

  const handleTrailChange = (trail) => {
    setSelectedTrail(trail);
  };

  return (
    <>
      <Helmet>
        <title>Tourism Offerings - Creative Twinning</title>
        <meta name="description" content="Discover authentic local accommodations, dining, and crafts along heritage trails in Serbia and Montenegro. Connect with local businesses and enhance your cultural journey." />
        <meta name="keywords" content="tourism, accommodation, hospitality, local products, Serbia, Montenegro, heritage trails, travel services" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header />
        
        {/* Header Section */}
        <OfferingsHeader
          totalCount={filteredOfferings?.length}
          activeCategory={activeCategory} />

        {/* Trail Selector Section */}
        <div className="bg-white border-b border-border">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
              <div>
                <h3 className="font-heading font-semibold text-foreground mb-1">Explore by Trail</h3>
                <p className="text-sm text-muted-foreground">Select a trail to discover local offerings along the route</p>
              </div>
              <div className="flex flex-wrap gap-2">
                <button
                  onClick={() => handleTrailChange('all')}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  selectedTrail === 'all' ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground hover:bg-muted/80'}`
                  }>
                  All Trails
                </button>
                {/* Montenegro Trails */}
                <button
                  onClick={() => handleTrailChange('kanjon-tare')}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  selectedTrail === 'kanjon-tare' ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground hover:bg-muted/80'}`
                  }>
                  Kanjon Tare
                </button>
                <button
                  onClick={() => handleTrailChange('srednjovjekovni-brskov')}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  selectedTrail === 'srednjovjekovni-brskov' ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground hover:bg-muted/80'}`
                  }>
                  Srednjovjekovni Brskov
                </button>
                <button
                  onClick={() => handleTrailChange('od-glecera-do-grebaje')}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  selectedTrail === 'od-glecera-do-grebaje' ?
                  'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground hover:bg-muted/80'}`
                  }>
                  Od glečera do Grebaje
                </button>
                <button
                  onClick={() => handleTrailChange('u-zagrljaju-sume')}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  selectedTrail === 'u-zagrljaju-sume' ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground hover:bg-muted/80'}`
                  }>
                  U zagrljaju šume
                </button>
                {/* Serbian Trails */}
                <button
                  onClick={() => handleTrailChange('zivot-kroz-vekove-golija')}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  selectedTrail === 'zivot-kroz-vekove-golija' ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground hover:bg-muted/80'}`
                  }>
                  Život kroz vekove
                </button>
                <button
                  onClick={() => handleTrailChange('listening-to-medieval-serbia')}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  selectedTrail === 'listening-to-medieval-serbia' ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground hover:bg-muted/80'}`
                  }>
                  Nemanjićevo nasleđe  
                </button>
                <button
                  onClick={() => handleTrailChange('trail-details-and-there-was-water-life-of-people-in-mountains-and-water')}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  selectedTrail === 'trail-details-and-there-was-water-life-of-people-in-mountains-and-water' ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground hover:bg-muted/80'}`
                  }>
                  I bi voda
                </button>
                <button
                  onClick={() => handleTrailChange('trail-details-once-upon-a-time-myths-and-legends-of-mountain-people')}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  selectedTrail === 'trail-details-once-upon-a-time-myths-and-legends-of-mountain-people' ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground hover:bg-muted/80'}`
                  }>
                  Bio jednom jedan
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {/* Category Filter */}
          <TourismCategoryFilter
            onFilterChange={handleCategoryChange}
            activeCategory={activeCategory} />

          <div className="lg:grid lg:grid-cols-4 lg:gap-8">
            {/* Advanced Filters Sidebar */}
            <div className="lg:col-span-1 mb-6 lg:mb-0">
              <LocationFilter
                onLocationChange={handleLocationChange}
                onPriceRangeChange={handlePriceRangeChange} />
            </div>

            {/* Offerings Grid */}
            <div className="lg:col-span-3">
              {/* Results Summary */}
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h2 className="font-heading font-semibold text-lg text-foreground">
                    {isLoading ? 'Loading...' : `${filteredOfferings?.length} Offerings Found`}
                  </h2>
                  <p className="text-muted-foreground text-sm">
                    {activeCategory === 'all' ? 'All categories' : activeCategory?.replace('-', ' ')}
                    {selectedTrail !== 'all' && ` on ${mockOfferings?.find((o) => o?.trail === selectedTrail)?.trailName || selectedTrail}`}
                    {selectedLocation !== 'all' && ` in ${selectedLocation?.replace('-', ' ')}`}
                  </p>
                </div>
              </div>

              {/* Offerings Grid */}
              <OfferingsGrid
                offerings={filteredOfferings}
                isLoading={isLoading} />
            </div>
          </div>
        </main>
      </div>
    </>);

};

export default TourismOfferings;